<!--除头部外的主体页面-->
<template>
  <div class="calendar pr">
    <!-- 主体部分除日例外左侧 -->
    <div class="calendarLeft" @click="closeCreateBox">
      <!-- <calendar-left :bookmark="bookmark" :addTemplateSucc="addTemplateSucc" @changeSource="chooseSource" @listChange="listChange" @currentSelectData="currentSelectData" @isNext="isNext" @editTemplate="editTemplate">
      </calendar-left> -->
      <page-left-resource :WhichPage="'Scheduler'" :bookmark="bookmark" @currentSelectData="currentSelectData" @editTemplate="editTemplate"></page-left-resource>
    </div>

    <!-- 日历左边放大功能 -->
    <magnify :dateInfo="dateInfo" :visible.sync="dateInfo.show" v-if="dateInfo.show" :events="events" :fixedDevice="selectR" :dynamicDevice="selectSource" @OperationSuccess="OperationSuccess" @close="closeCreateBox"></magnify>
    <!-- 日历左边放大滚动条 -->
    <div class="magnifying" v-show="!IsShowTemplate">
      <div class="header" style="height: 42px; border-bottom: 1px solid #333"></div>
      <div class="body">
        <div class="mnf_content" :style="{ height: `${calendarHeight}px` }">
          <div class="mnf_btn" v-for="(item, index) in magnifyingBtns" :key="index">
            <button class="ellipsis" @click="openCalendar(index)">
              {{ $t("lang.magnifying") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 日历主体 -->
    <div class="calendar_box" v-show="!IsShowTemplate">
      <!-- 播放剩余时间？ -->
      <div class="count_down f_left clearfix" :title="`${nextEvent.tname},${nextEvent.rname},${nextEvent.eventName},${countDownTime}`" :class="{ visib: countDownTime != '00:00:00' }">
        <span class="f_left ellipsis">{{ nextEvent.tname }}</span>
        <span class="f_left ellipsis">,{{ nextEvent.rname }}</span>
        <span class="f_left ellipsis">,{{ nextEvent.eventName }}</span>
        <span class="f_left ellipsis">,{{ countDownTime }}</span>
      </div>
      <!-- 年月日的选择 -->
      <div class="cal_date_opt f_left">
        <i class="iconfont pointer" @click="preDate">&#xe604;</i>
        <el-date-picker v-model="dateTitle" type="date" popper-class="pick_date_time" class="date_option" @change="changeDateView"></el-date-picker>
        <i class="iconfont pointer" @click="nextDate">&#xe61b;</i>
      </div>
      <!-- 时间日历插件 -->
      <full-calendar class="calendarEventWrap" ref="calendar" v-if="calendarFlag" v-loading="loadingCalendar" element-loading-background="rgba(0, 0, 0, .6)" :event-sources="eventSources" @event-selected="eventSelected" @event-created="eventCreated" @day-click="dayClick" :key="keycount" :config="calendarConfig"></full-calendar>
      <!-- 创建框 -->
      <popup-box v-if="EventMotion.switch" :picthOnEvent="picthOnEvent" :EventMotion="EventMotion.motion" :fixedDevice="selectR" :BoxPosition="createBox" @closeCreateBox="closeCreateBox" @OperationSuccess="OperationSuccess"></popup-box>
    </div>

    <!-- 模板 -->
    <div class="CreateTemplate" v-if="IsShowTemplate == 1">
      <event-template :WeekTitle="TemplateScheduleType" :TemplateBodyMessage="TemplateBodyMessage" :fixedDevice="selectR" :dynamicDevice="selectSource" @CancelTemplate="CancelTemplate"></event-template>
    </div>
    <!-- program模板 -->
    <div class="ProgramTemplateEdit" v-if="IsShowTemplate == 2">
      <template-page-right @closeProgramTemplate="CancelTemplate"></template-page-right>
    </div>
    <!-- 保存当天模板 -->
    <el-dialog class="SaveDayTemplate" :title="$t('lang.saveTip')" :visible.sync="daySaveVisible" width="400" :rules="{ required: true }">
      <el-form :model="dayForm">
        <el-form-item :label="$t('lang.name')">
          <el-input v-model="dayForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daySaveVisible = false">{{ $t("lang.cancel") }}
        </el-button>
        <el-button type="primary" @click="daySaveName()">{{ $t("lang.btn") }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 右击事件操作 -->
    <div class="MouseRightClick" data-id="MouseRightClick" v-if="OperationStyle.Switch" :style="OperationStyle">
      <div class="operation" data-id="MouseRightClick" @click="DeleteMoreEvent">
        {{ $t('lang.delete') }}
      </div>
      <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent(false, 'Move')">
        {{ $t('lang.Move') }}
      </div>
      <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent(false, 'Duplicate')">
        {{ $t('lang.duplicate') }}
      </div>
    </div>
    <time-select v-if="MoveandCopyTime.show" :MoveandCopyTime="MoveandCopyTime" @ApplyStartFrom="ApplyStartFrom"></time-select>
  </div>
</template>
<script>
import Outil from '../../assets/js/utils.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import toTips from '@/assets/js/toTipsObj'
import magnify from './magnify'
// import calendarLeft from './PlayoutLeft'
import PageLeftResource from '@/components/common/PageLeftResource.vue'
import Bus from '@/assets/js/vueBus.js'
import EventTemplate from './EventTemplate.vue'
import PopupBox from '@/components/common/PopupBox.vue'
import TemplatePageRight from '@/views/ProgramTemplate/TemplatePageRight.vue'
import TimeSelect from './common/TimeSelect.vue'
import { creatAccount } from '@/assets/js/common/creatAccount.js'

const googleKey = 'playout'
export default {
  components: {
    magnify,
    EventTemplate,
    PopupBox,
    TimeSelect,
    PageLeftResource,
    TemplatePageRight
  },
  props: ['bookmark', 'temRenameStatus'],
  data () {
    return {
      MockDataId: 100,
      MockData: [],
      // 夏令时时间
      DstTime: {
        isDst: false
      },
      // move，copy操作选择时间
      MoveandCopyTime: {
        type: 'Move',
        show: false
      },
      // 右击操作样式
      OperationStyle: {
        Switch: false
      },
      // MAC的ctrl是否按下
      MACCtrl: false,
      // ctrl是否按下
      CtrlDown: false,
      // ctrl是否选中event
      CtrlPitch: false,
      // ctrl选中event的列表
      PitchEventList: {},
      // 页面所有事件
      PageAllEvent: [],
      // 选中事件对象
      picthOnEvent: {},
      // 弹窗的动作,对于事件
      EventMotion: {
        switch: false,
        motion: 0
      },
      // 是否点击图标
      IsClickIcon: false,
      // 模板类型
      TemplateScheduleType: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      // 查询模板的信息
      TemplateBodyMessage: {},
      // 是否显示模板
      IsShowTemplate: 0,
      editEventStart: '', // 编辑时的添加时间
      currentSelectPeerid: '', // 所选rid
      daySaveVisible: false, // 按天保存
      dayTime: '', // 按天保存
      dayForm: {
        name: ''
      },
      // 使用模板
      templateDetailStatus: false,
      renameForm: {},
      addTemplateSucc: false, // 模板添加成功后渲染左侧列表
      type: '', // 保存模板类型
      keycount: 0,
      bindCreBoxRScroll: {
        // 创建框中的r绑定滚动事件
        onScroll: this.handleCreBoxRScroll,
        distance: 10,
        directive: '.scroll_box ul'
      },
      // 日历左边放大
      dateInfo: {
        show: false,
        date: {
          start: '',
          end: '',
          date: [],
          weekTitle: []
        }
      },
      dateArr: {
        date: [],
        weekTitle: []
      },
      calendarFlag: true,
      eventListFlag: true,
      loadingCalendar: false,
      colorArr: [
        {
          name: 'green',
          value: 'rgb(15, 190, 113)'
        },
        {
          name: 'skyblue',
          value: 'rgb(70, 201, 225)'
        },
        {
          name: 'blue',
          value: 'rgb(14,107,209)'
        },
        {
          name: 'orange',
          value: 'rgb(255, 197, 115)'
        },
        {
          name: 'pink',
          value: 'rgb(255, 106, 146)'
        },
        {
          name: 'yellow',
          value: 'rgb(255, 192, 0)'
        },
        {
          name: 'purple',
          value: 'rgb(146, 72, 199)'
        }
      ],
      calendarHeight: '',
      countDownTime: '00:00:00',
      nextEvent: {
        tname: '',
        rname: '',
        eventName: ''
      },
      timer: {
        countDown: null,
        events: null,
        curEvent: null,
        refetchEvent: null
      },
      event: {
        title: '',
        source: '',
        rname: '',
        tname: '',
        description: '',
        destination: '',
        delay: '',
        bit: '',
        reporter: '',
        startTime: '',
        stopTime: '',
        color: 'rgb(15, 190, 113)',
        rpeerid: '',
        tpeerid: '',
        ttype: '',
        turl: '',
        eventId: '',
        duration: '',
        // spliceType: '',
        prerollTime: ''
      },
      deleteId: '',
      loading: {
        source: false
      },
      addBookingParam: {
        title: '',
        rpeerid: '',
        tpeerid: '',
        startTime: '',
        endTime: '',
        description: '',
        delay: '',
        reporter: '',
        color: '',
        ttype: '',
        turl: '',
        bitrate: '',
        tname: ''
      },
      calendar: {
        searchS: false,
        searchR: false,
        filterBox: false
      },
      pickerDateBeg: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      pickerDateEnd: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      filterOptions: [
        'lang.tvuPack',
        'lang.tvuAnywhere',
        'lang.gridPack',
        'lang.gridSDI',
        'Ext',
        'token',
        'scte'
      ],
      filterList: [],
      checkAll: true,
      checkedFilterList: [
        'lang.tvuPack',
        'lang.tvuAnywhere',
        'lang.gridPack',
        'lang.gridSDI',
        'Ext',
        'token',
        'scte'
      ],
      isIndeterminate: false,
      timeFlag: 0,
      createBox: {
        // 创建框的位置
        left: 0,
        top: 0,
        triangle: false,
        bottom: false
      },
      createStartTime: '',
      createStopTime: '',
      startDate: '',
      dateTitle: '', // 日历头部时间title
      events: [],
      dragEvent: {},
      eventFrom: '',
      lastSourceCondition: '',
      calendarConfig: {
        // full-calendar的配置参数
        // buttonText: this.viewBtns,
        // timezoneParam: 'UTC',
        // timezone: 'America/Anchorage',
        buttonText: {
          today: this.$t('lang.todayKey'),
          month: this.$t('lang.monthKey'),
          week: this.$t('lang.weekKey'),
          day: this.$t('lang.dayKey')
        },
        header: {
          left: '',
          center: 'prev,title,next'
        },
        navLinks: true,
        selectable: true,
        selectHelper: true,
        dayRender: (date, cell) => { },
        firstDay: 1, // 设置周几为第一天
        columnFormat: 'ddd M/D',
        // slotDuration: '00:00:10',
        defaultView: 'agendaWeek',
        allDaySlot: false,
        firstHour: 1,
        slotEventOverlap: false, // 事件不可重叠
        editable: true, // 事件不可拖动缩放
        eventDurationEditable: false,
        eventStartEditable: true,
        eventLimit: true, // allow "more" link when too many events
        // contentHeight: document.body.offsetHeight - 190,
        contentHeight: 800,
        // timeFormat: ,
        unselectAuto: false, // 设置当点击页面其他地方的时候，是否清除已选择的区域，值为布尔类型
        // columnFormat: '',
        dragRevertDuration: '1000',
        loading: (isLoading, view) => {
          // isLoading=false时为加载完成,true是正在加载
          // 添加时间选择
          if (
            $('.calendar_box .el-date-editor.el-date-editor--date').find(
              '.replace_title'
            ).length == 0
          ) {
            $('.calendar_box .el-input__inner').after(
              '<p class="replace_title"></p>'
            )
          }

          // 整个日历阻止冒泡
          $('.fc-body').on('click', (e) => {
            e.stopPropagation()
          })
          // 显示时间标题
          this.changeCalTitle()
          // 边上时间转换大写
          this.LeftNavDate()
          // isLoading=false时为加载完成,true是正在加载
          if (!isLoading) {
            var time = view.calendar.currentDate._d
            this.dateTitle =
              `${time.getFullYear()
              }-${
              Outil.timeFormat(time.getMonth() + 1)
              }-${
              Outil.timeFormat(time.getDate())}`
            // 监听切换月周日历视图
            $('.fc-button-group button').on('click', () => {
              playoutAnalyze('welcomeViewSwitch')
              this.LeftNavDate()
              this.changeCalTitle()
              // 删除月视图的日期
              this.DeleteMonthDate()
              // 阻止冒泡
              $('.fc-body').on('click', (e) => {
                e.stopPropagation()
              })
              this.getBookingEventAccodT()
              // 添加DR图标
              this.AddDRicon()
              this.initScroll()
            })
          }
          // 添加下划线
          $('.cal_date_opt .el-input__inner').on('mouseenter', () => {
            $('.replace_title').css('text-decoration', 'underline')
          })
          $('.cal_date_opt .el-input__inner').on('mouseleave', () => {
            $('.replace_title').css('text-decoration', 'none')
          })
        },
        viewRender: (view, element) => {
          // 渲染视图后
          // 更新表格标题
          var title = $('.fc-toolbar .fc-center h2').html()
          $('.cal-header .cal-date').html(title)
          // 更新模式选择
          var lis = $('.cal-type li')
          lis.map((item, idx) => {
            if ($(item).attr('data-type') === view.type) {
              $(item).addClass('active').siblings('li').removeClass('active')
            }
            return 1
          })
          $('.fc-day-header').append(
            '<i class="iconfont icon-save" style="margin-left:10px;vertical-align: middle;font-size:30px"></i> <i class="iconfont icon-clear" style="margin-left:5px;vertical-align: middle;font-size:15px"></i>'
          )
          $('.fc-day-header .icon-save').on('click', (e) => {
            creatAccount()
          })
          $('.fc-day-header .icon-clear').on('click', (e) => {
            creatAccount()
          })
        },
        // 点击被创建的事件
        eventClick: (event, jsEvent, view) => {
          playoutAnalyze('welcomeEventClick')
          // event点击的事件
          // jsEvent点击的元素
          // let start = Outil.getDateTime(event.start._d);
          // let stop = Outil.getDateTime(event.end._d);
          this.eventDuration = event.end._d.getTime() - event.start._d.getTime()
          // 编辑
          this.isShow.edit = true
          // 点击哪个的dom元素
          this.jsEventObj = jsEvent.currentTarget

          this.eventFrom = ''
          if (this.timer.curEvent) {
            // 如果有定时器，先清除定时器
            clearInterval(this.timer.curEvent)
            this.timer.curEvent = null
          }
          this.curEventCountDown = null // 初始化点开的当前事件倒计时为null
          // 点击图标
          if (this.IsClickIcon) {
            this.IsClickIcon = false
          }
          // ctrl加click选中
          if (this.CtrlDown) {
            this.CtrlClickMouse(event)
          }
          // mac的ctrl按着不操作
          // 点击事件  编辑框内的数据
          if (!this.CtrlDown && !this.MACCtrl) this.fillCreateBox(event)
        },
        // 点击选择时间去创建事件,选中日历格事件
        select: (start, end, event, view, resource) => {
          playoutAnalyze('welcomeViewBlankClick')
          // var id = new Date().getTime();
          var UTCStartTime = Outil.getUTCTime(start._d)
          var UTCEndTime = Outil.getUTCTime(end._d)
          // var startDate = new Date(UTCStartTime);
          // var endDate = new Date(UTCEndTime);
          // 获取当前点击格子中的最后一个事件
          const preEvent = this.getPreEvent(UTCStartTime, UTCEndTime)
          if (preEvent) {
            const differ = UTCEndTime - UTCStartTime
            UTCStartTime = preEvent.endTime
            UTCEndTime = UTCStartTime + differ
          }
          // 点击空白处创建
          this.ClickandDragCreate({
            startTime: new Date(UTCStartTime),
            endTime: new Date(UTCEndTime)
          }, event, 0)
          $('a.fc-time-grid-event.fc-event.fc-helper').addClass('antline')
          playoutAnalyze(`${googleKey}CalendarCreateBoxOpen`, '/po')
        },
        selectAllow: (selectInfo) => {
          // 自定义可选取范围
          var date = selectInfo.start._d
          // var UTCStartTime = date.getTime() + date.getTimezoneOffset() * 60000;
          var UTCStartTime = Outil.getUTCTime(date)
          if (UTCStartTime < new Date()) {
            if (this.EventMotion.switch) {
              // 不取消上次选中时间
              $('#calendar').fullCalendar(
                'select',
                this.startDate,
                this.endDate
              )
            }
            return false
          } else {
            return true
          }
        },
        dayClick: (event, jsEvent, view) => {
          jsEvent.stopPropagation()
          this.selected = event
        },
        // 拖动开始前
        eventDragStart: (event, jsEvent, ui, view) => {
          this.eventDragAgain = event.id == this.dragEvent.id
          $('#calendar').fullCalendar('unselect')
          this.initEventData()
        },
        // 拖动停止触发
        eventDragStop: (event, jsEvent, ui, view) => {
          if (this.eventDragAgain) {
            return true
          }
          // 重复拖拽时去掉上一个
          if (this.dragEvent.id) {
            $('#calendar').fullCalendar('removeEvents', this.dragEvent.id)
            // 初始化数据
            this.initEventData()
          }
          if (this.dragEvent.id && event.id != this.dragEvent.id) {
            // 拖动后再去拖另一个事件，还原上次拖动的事件
            let lastEvent
            for (let i = 0; i < this.events.length; i++) {
              if (this.events[i].id == this.dragEvent.id) {
                lastEvent = this.events[i]
                break
              }
            }
            $('#calendar').fullCalendar('renderEvent', lastEvent, true)
          }
          this.dragEvent = {
            id: `${event.id}`,
            start: event.start._d.getTime(),
            end: event.end._d.getTime()
          } // 记录拖动的目标事件
        },
        // 拖动到位置后停止触发
        eventDrop: (
          event,
          dayDelta,
          minuteDelta,
          jsEvent,
          revertFunc,
          allDay,
          ui,
          view
        ) => {
          this.getBookingEventAccodT()
          // event时间有问题所以要计算一下
          // 计算拖动之后所在模块的时间
          // const startTime = new Date(
          //   this.dragEvent.start + dayDelta._milliseconds + dayDelta._days * 24 * 60 * 60 * 1000
          // )
          // const stopTime = new Date(
          //   this.dragEvent.end +
          //   dayDelta._milliseconds +
          //   dayDelta._days * 24 * 60 * 60 * 1000
          // )
          // if (startTime.getTime() < new Date().getTime()) {
          //   // 拖拽到已经过去的时间时去掉这个事件
          //   if (this.dragEvent.id) {
          //     $('#calendar').fullCalendar('removeEvents')
          //     $('#calendar').fullCalendar('renderEvents', this.events, true)
          //     // 初始化数据
          //     // this.initEventData();
          //   }
          //   return
          // }

          // this.dragEvent.start = startTime.getTime()
          // this.dragEvent.end = stopTime.getTime()
          // const eventObj = event
          // eventObj.start._d = startTime
          // eventObj.end._d = stopTime
          // // 换时间上显示的时间
          // const start = this.transitionHourly(startTime)
          // const stop = this.transitionHourly(stopTime)
          // this.jsEventObj = $(`a.fc-event.fc-draggable.${event.id}`)
          // const title = event.title.split(' ')[1]
          // $(`a.fc-event.fc-draggable.${event.id} .fc-title`).html(
          //   `${start} - ${stop} ${title}`
          // )
          // setTimeout(() => {
          //   this.fillCreateBox(eventObj, jsEvent, 1)
          // }, 100)
          // if (event.startTime <= new Date().getTime()) {
          //   // 如果事件已经开始执行，禁止拖动
          //   this.closeCreateBox()
          // }
        }
      },
      selected: {},
      sourcePar: {
        // 获取源列表的参数
        condition: '',
        bookmardIds: 'all',
        unClassified: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        token: true,
        scte: true,
        pageNum: 1,
        pageSize: 35
      },
      // sourceId: '',
      sourceList: [], // 源列表
      totalPage: {
        // 设备的总页数
        source: 1,
        r: 1
      },
      lastCondition: {
        // 最后一次搜索的条件
        source: '',
        r: ''
      },
      rPar: {
        // 获取R列表的参数
        condition: '',
        tpeerId: '',
        bookmardIds: 'all',
        unClassified: true,
        pageNum: 1,
        pageSize: 35
      },
      selRName: '',
      lastLeftRPageNum: 1,
      // lastrightRPageNum: 1,
      lastSourcePageNum: 1,
      // rList: [],
      chooseSIndex: 0, // 选中的源下标
      // chooseRIndex: null,     // 选中的R下标
      creating: false, // 正在创建的左头部Booking信息
      creatingObj: {
        // 创建中的booking信息
        source: '',
        r: '',
        time: ''
      },
      isShow: {
        showColorOpt: false,
        createBox: false,
        note: true,
        showHeight: false,
        createBoxSourceList: false,
        bookmark: true,
        edit: true,
        editDelay: false,
        editBit: false,
        deleteBtn: true,
        rList: true,
        sourceList: true,
        create: true
      },
      isCopy: false,
      curLiveStatus: null,
      sourceType: '',
      disable: {
        input: false
      },
      selectR: {},
      selectSource: {},
      magnifyingBtns: 50,
      selColor: {
        name: 'yellow',
        value: 'rgb(255, 192, 0)'
      },
      // addFlag: true,
      createSourceList: [], // 创建框中的R列表
      jsEventObj: '',
      bookmarkArr: [],
      selBookmarkLength: this.bookmark.length,
      curEventCountDown: null,
      eventDuration: '',
      eventDetail: {
        // 点击booking后的展示框内数据
        title: '',
        time: '',
        reporter: '',
        description: '',
        source: '',
        r: ''
      },
      heavyLoadObj: {
        active: {
          delay: false,
          bitrate: false
        }
      },
      oldMediaInfo: {}
    }
  },
  created () {
    this.currentSelectData({
      available: '0',
      broadcastDay: 6,
      id: 'aaaaaaaaaaa',
      name: 'haha',
      peerId: 'aaaaaaaaaaa',
      platform: '15',
      postion: 0,
      remark: '',
      status: '1',
      timeStamp: '1635061975554',
      times: '15',
      tokenStatus: null,
      type: 'R',
      url: '',
      version: '7.7'
    })
    this.filterList = this.filterOptions // filter选项初始化
    // this.getSourceList();
    this.createStartTime = new Date()
    this.createStopTime = new Date()
    // window.addEventListener('resize', this.handleResize)
    this.handleResize()
    Outil.heavyLoad(this.heavyLoadObj, 'change', 2, this.changeActiveStatus, this)
    // 获取今年的夏令时时间
    const DstTime = Outil.DisplayDstSwitchDates(new Date().getYear())
    this.DstTime = DstTime
    this.halfAnHour()
    setTimeout(() => {
      this.getBookingEventAccodT()
    }, 200)
    Bus.$on('leftListUpdate', this.registerDrag)
  },
  mounted () {
    // 行为同步
    Bus.$on('BehaviorChange', (data) => {
      console.log('sc-calendar')
      if (typeof data != 'object') return
      if (data.action == 'EventListChange' || (data.action == 'playoutPreviewStatusModule' && data.isRefreshPlayList)) {
        this.getBookingEventAccodT()
      }
    })
    // document.body.addEventListener('click', '#calendar .fc-toolbar.fc-header-toolbar')
    $('body').on('click', '#calendar .fc-toolbar.fc-header-toolbar', () => {
      this.closeCreateBox()
    })
    // this.MonitorCtrl()
  },
  watch: {
    'dateInfo.show' (val) {
      this.$nextTick(() => {
        if (!val) {
          this.dragToCreateEvent()
        }
      })
    }
  },
  methods: {
    // 半个小时事件
    halfAnHour () {
      const date = new Date().getTime()
      const hour = new Date().getHours()
      const Time = Outil.changeNewDate(date)
      const FirstStartTime = new Date(`${Time} ${hour}:00:00`).getTime()
      for (let i = 0; i < 24; i++) {
        const item = {
          bitrate: '5000',
          color: 'rgb(255, 192, 0)',
          delay: '2',
          description: 'Make your stories come alive',
          duration: '',
          endTime: 1635116400000,
          eventId: i * 100,
          eventSegments: [],
          houseId: '',
          id: i * 100,
          liveStatus: 0,
          record: 0,
          reporter: '',
          rname: '',
          rpeerid: 'aaaaaaaaaaa',
          sourceType: 0,
          startTime: 1635112800000,
          title: 'Make your stories come alive',
          tname: 'Make your stories come alive',
          tpeerid: '555789145485648878485',
          ttype: 'video'
        }
        item.startTime = FirstStartTime + i * 60 * 60 * 1000
        item.endTime = item.startTime + 60 * 60 * 1000
        this.MockData.push(item)
      }
    },
    // 判断是什么操作系统
    JudgeOperating () {
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      console.log('JudgeOperating', isMac)
      if (isMac) {
        return true
      } else {
        return false
      }
    },
    // ctrl加click选中 ctrl按下
    MonitorCtrl () {
      this.$nextTick(() => {
        const isMac = this.JudgeOperating()
        document.onkeydown = (e) => {
          if ((e.key === 'Control' && !isMac) || (e.key === 'Shift' && isMac)) {
            if (!this.EventMotion.switch) {
              if (!this.CtrlDown) {
                this.CtrlDown = true
                this.MonitorRightClick()
              }
            }
          }
          // 兼容mac的ctrl加左击操作
          if (e.key === 'Control' && isMac) {
            this.MACCtrl = true
          }
        }
        document.onkeyup = (e) => {
          if ((e.key === 'Control' && !isMac) || (e.key === 'Shift' && isMac)) {
            if (this.CtrlDown) {
              this.CtrlDown = false
              if (Object.keys(this.PitchEventList).length == 0) {
                // 清除
                this.ClearMultiple()
              }
            }
          }
          if (e.key === 'Control' && isMac) {
            this.MACCtrl = false
          }
        }
      })
    },
    // ctrl加click选中 点击选中
    CtrlClickMouse (PitchItem) {
      const PitchIndex = this.PitchEventList[PitchItem.id]
      if (PitchIndex) {
        delete this.PitchEventList[PitchItem.id]
        $(`#calendar .${PitchItem.id}`).css('border', 'solid 0px transparent')
      } else {
        this.PitchEventList[PitchItem.id] = PitchItem
        $(`#calendar .${PitchItem.id}`).css('border', 'solid 5px #83ED7C')
      }
    },
    // 监听鼠标右击
    MonitorRightClick () {
      document.oncontextmenu = (e) => {
        // 鼠标右键点击
        if (e.button == 2 || (e.button == 0 && this.MACCtrl)) {
          if (Object.keys(this.PitchEventList).length > 0) {
            e.preventDefault()
            this.OperationStyle = {
              top: `${e.pageY}px`,
              left: `${e.pageX > 1790 ? 1790 : e.pageX}px`,
              Switch: true
            }
          }
        }
      }
      document.onmouseup = (e) => {
        // 鼠标左键点击
        if (e.button == 0) {
          setTimeout(() => {
            if (!this.MACCtrl) {
              this.$set(this.OperationStyle, 'Switch', false)
            }
            // 是否是对选中的事件进行操作
            if (e.target.dataset && e.target.dataset.id === 'MouseRightClick') return
            // Ctrl,shift还在按着或者正在移动copy
            if (this.CtrlDown || this.MoveandCopyTime.show || this.MACCtrl) return
            // 清除
            this.ClearMultiple()
          }, 100)
        }
      }
    },
    // 清除鼠标点击，以及多选操作
    ClearMultiple () {
      document.oncontextmenu = null
      document.onmouseup = null
      for (const key in this.PitchEventList) {
        $(`#calendar .${key}`).css('border', 'solid 0px transparent')
      }
      this.PitchEventList = {}
      this.$set(this.OperationStyle, 'Switch', false)
    },
    // 删除多个事件
    DeleteMoreEvent () {
      this.$confirm(this.$t('lang.prompEnsureDel'), '', {
        confirmButtonText: this.$t('lang.btn'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const param = this.multiOperationParam('delete')
        this.axios({
          method: 'post',
          url: Outil.getUrl('/event/delete'),
          data: { ids: param },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getBookingEventAccodT()
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.ClearMultiple()
        }).catch()
      }).catch(() => {
        // 取消操作
      })
    },
    // CopyandMove事件
    CopyandMoveEvent (value, type, time) {
      if (!value) {
        this.MoveandCopyTime.type = type
        this.MoveandCopyTime.show = true
      } else {
        let url
        if (type == 'Move') {
          url = '/event/moveEvents'
        } else {
          url = '/event/copyEvents'
        }
        const param = {
          rid: this.selectR.peerId,
          eventIds: this.multiOperationParam(type),
          coverEvent: false,
          startTime: time
        }
        this.axios({
          method: 'post',
          url: Outil.getUrl(url),
          data: param,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            // 删除成功后刷新列表
            this.getBookingEventAccodT()
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.ClearMultiple()
        }).catch()
      }
    },
    // 选择copy，move时间
    ApplyStartFrom (time) {
      creatAccount()
      // this.MoveandCopyTime.show = false
      // this.CopyandMoveEvent(true, this.MoveandCopyTime.type, time)
    },
    // delete，copy，move参数转换
    multiOperationParam (type) {
      const paramList = []
      for (const key in this.PitchEventList) {
        paramList.push(this.PitchEventList[key].id)
      }
      if (type == 'delete') {
        return paramList
      } else {
        return paramList.join(',')
      }
    },
    // 24小时制转12小时制
    transitionHourly (time) {
      if (time) {
        let type = ''
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
        // hour = hour >= 0 && hour < 10 ? `0${hour}` : hour;
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${hour}:${min}:${s} ${type}`
      }
    },
    // 删除月视图的日期
    DeleteMonthDate () {
      const type = $('#calendar').fullCalendar('getView').name
      if (type == 'month') {
        $('.fc-day-header i').remove()
        const calendarTitle = $('.fc-day-header span')
        calendarTitle.map((index, item) => {
          const title = $(item).text()
          $(item).text(title.split(' ')[0])
          return 1
        })
      }
    },
    // 取消编辑模板
    CancelTemplate () {
      this.IsShowTemplate = 0
      this.registerDrag()
    },
    // 保存当天为模板
    daySaveName () {
      var dayStart = Date.parse(new Date(this.dayTime)) // 2016-12-29 0:0:0
      const date = new Date(dayStart)
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset()) // 差8个小时
      dayStart = Date.parse(date)
      var dayEnd = new Date().setTime(
        (dayStart / 1000 + 24 * 60 * 60 - 1) * 1000
      ) // 2016-12-29 23:59:59
      this.dayForm = {
        name: this.dayForm.name,
        type: 1,
        startTime: dayStart,
        endTime: dayEnd,
        rid: this.currentSelectPeerid,
        scheduleType: 2 // 日模板
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/saveAsTemplate', this.dayForm).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.daySaveVisible = false
            this.addTemplateSucc = !this.addTemplateSucc
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      })
    },
    // 删除一天的事件
    DeleteDayEvent (dayTime) {
      const startTime = new Date(`${dayTime} 00:00:00`).getTime()
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/deleteEventByDay',
        {
          rid: this.selectR.peerId,
          startTime
        }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.getBookingEventAccodT()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      })
    },
    // 判断是哪种模板进入next
    isNext (data) { },
    // 编辑模板
    editTemplate (data) {
      if (data.name == 'programTemplate') {
        if (data.status) this.IsShowTemplate = 2
        if (!data.status && this.IsShowTemplate == 2) this.IsShowTemplate = 0
        // this.$nextTick(() => {
        //   this.IsShowTemplate = 2
        // })
      } else {
        this.IsShowTemplate = 0
        if (data.name == 'scheduleVis') {
          this.TemplateBodyMessage = data.data
          if (data.data.scheduleType == 2) {
            this.TemplateScheduleType = []
            this.TemplateScheduleType.push('Day')
          } else {
            this.TemplateScheduleType = []
            this.TemplateScheduleType.push(
              ...['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            )
          }
        } else {
          this.TemplateBodyMessage = data.data
          this.TemplateScheduleType = []
        }
        this.$nextTick(() => {
          this.IsShowTemplate = 1
        })
      }
    },
    // 当前方格范围内的前一个最近事件
    getPreEvent (scopeStart, scopeEnd) {
      const scopeEvent = []
      let preEvent
      this.events.forEach((v) => {
        // 事件的结束时间是否在方格时间范围内
        if (v.endTime >= scopeStart && v.endTime <= scopeEnd) {
          scopeEvent.push(v)
        }
      })
      scopeEvent.sort((a, b) => a.startTime - b.startTime)
      // 如果点击分钟内有事件，开始时间紧跟这分钟内的结束时间
      if (scopeEvent.length) {
        preEvent = scopeEvent[scopeEvent.length - 1]
      }
      return preEvent
    },
    registerDrag () {
      this.$nextTick(() => {
        this.dragToCreateEvent()
      })
    },
    // 列表变动
    listChange () {
      this.$nextTick(() => {
        this.dragToCreateEvent()
      })
    },
    // 元素绑定拖拽事件
    dragToCreateEvent (viewObj) {
      const view = viewObj || $('#calendar').fullCalendar('getView')
      let target
      const sourceList = document.querySelectorAll('.draggable_box .draggable_item')
      let dragElement = null
      const targetX = $('#calendar').offset().left
      let timeArr = []
      this.dateInfo.date.weekTitle = [undefined]
      for (let i = 0; i < sourceList.length; i++) {
        // 拖拽开始的时候触发
        const that = this
        sourceList[i].ondragstart = function () {
          dragElement = this // eslint-disable-line
          // 区别于template，medialist， live的拖动
          // 判断是否存在scheduleType属性
          if (Object.prototype.hasOwnProperty.call(JSON.parse(dragElement.dataset.device), 'scheduleType')) that.templateDetailStatus = true
        }
      }
      switch (view.name) {
        case 'month':
          target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
          break
        case 'agendaWeek':
          target = document.querySelector('.fc-slats table tbody')
          break
        case 'agendaDay':
          target = document.querySelector('.fc-slats table tbody')
          break
        case 'magnify':
          target = document.querySelector('.magnify .content .tbody')
          break
        default:
          target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
          break
      }
      if (!target) {
        setTimeout(() => {
          switch (view.name) {
            case 'month':
              target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
              break
            case 'agendaWeek':
              target = document.querySelector('.fc-slats table tbody')
              break
            case 'agendaDay':
              target = document.querySelector('.fc-slats table tbody')
              break
            case 'magnify':
              target = document.querySelector('.magnify .content .tbody')
              break
            default:
              target = document.querySelector('.fc-body .fc-day-grid.fc-unselectable')
              break
          }
        }, 100)
      }
      // 周日历或者是放大周.....将日期赋给this.dateInfo.date.date
      if (
        view.name == 'agendaWeek' ||
        (view.name == 'magnify' && this.dateInfo.date.date.length > 1)
      ) {
        const timeEle = $('.fc-head-container .fc-day-header')
        timeArr = []
        timeEle.map((i, v) => {
          timeArr.push($(v).attr('data-date'))
          this.dateInfo.date.weekTitle.push($(v).find('a').html())
          return 1
        })
        this.dateInfo.date.date = timeArr
      }
      // 日 日历或者是放大日
      if (
        view.name == 'agendaDay' ||
        (view.name == 'magnify' && this.dateInfo.date.date.length == 1)
      ) {
        const timeEle = $('.fc-day-header.fc-widget-header')
        this.dateInfo.date.date = [timeEle.attr('data-date')]
        this.dateInfo.date.weekTitle = [undefined, timeEle.find('span').html()]
      }
      if (view.name == 'magnify') return

      target.ondragover = function (e) {
        // 阻止默认事件
        // console.log(e,'ondragover');
        e.preventDefault()
      }
      // drop事件默认是触发不了的，需要在dragover事件里面阻止默认事件
      target.ondrop = (e) => {
        const templateDetailStatus = dragElement.dataset.template
        const programTemplate = dragElement.dataset.programtemplate
        if (!templateDetailStatus) {
          let startDate // 落下所在块的时间2021/03/11 06:30:00
          let stopDate // 2021/03/11 07:00:00
          let distance // 落下的位置距离日历边缘距离
          let index // 落下周几
          let date // 落下的日期2021/03/11
          // 获取落到那一天的哪一半
          let IsLeftHalf = false
          if (view.name === 'month') {
            index =
              $(e.target).parent().find('td').index($(e.target)) -
              $(e.target).parent().find('.fc-more-cell').length
            const parent = $(e.target).parents(
              '.fc-row.fc-week.fc-widget-content.fc-rigid'
            )
            const targetEle = parent.find(`.fc-day:eq(${index})`)
            startDate = `${$(targetEle)
              .attr('data-date')
              .replace(/-/g, '/')} 00:00:00`
            const stop = Outil.getDateTime(
              new Date(new Date(startDate).getTime() + 24 * 60 * 60 * 1000)
            )
            stopDate = `${stop.year}/${stop.month}/${stop.day} ${stop.hour}:${stop.min}:${stop.s}`
            distance = e.clientX - targetX
          } else if (view.name === 'agendaWeek') {
            const startTime = $(e.target).parent().attr('data-time')
            const stopTime =
              startTime.split(':')[1] == '30'
                ? `${Number(startTime.split(':')[0]) + 1}:00:00`
                : `${startTime.split(':')[0]}:30:00`
            // 落下的位置距离日历边缘距离
            distance = e.clientX - targetX - 39
            index = Math.floor(
              distance / (($(e.target).width() - 2) / 7).toFixed(2)
            )
            IsLeftHalf = Math.floor(distance / (($(e.target).width() - 2) / 14).toFixed(2)) % 2 == 0
            date = timeArr[index].replace(/-/g, '/')
            startDate = `${date} ${startTime}`
            this.editEventStart = `${timeArr[index]} ${startTime}`
            stopDate = `${date} ${stopTime}`
            // 小于当前时间不可创建
            // if (new Date(startDate).getTime() <= new Date()) {
            //     this.$message.error(this.$t('lang.startTimeLessThanCurTime'));
            //     return;
            // }
          } else if (view.name === 'agendaDay') {
            distance = e.clientX - targetX - 39
            IsLeftHalf = Math.floor(distance / (($(e.target).width() - 2) / 2).toFixed(2)) % 2 == 0
            date = $('.fc-day-header.fc-widget-header')
              .attr('data-date')
              .replace(/-/g, '/')
            const start = $(e.target).parent().attr('data-time')
            startDate = `${date} ${start}`
            const time = Outil.getDateTime(
              new Date(new Date(startDate).getTime() + 30 * 60 * 1000)
            )
            stopDate = `${time.year}/${time.month}/${time.day} ${time.hour}:${time.min}:${time.s}`
          } else if (view.name === 'magnify') {
            startDate = `${$(e.target).attr('data-date')} ${$(e.target).attr(
              'data-time'
            )}`
            stopDate = new Date(startDate).getTime() + 1000
          }
          // 小于当前时间不可创建
          if (new Date(startDate).getTime() <= new Date()) {
            this.$message.error(this.$t('lang.startTimeLessThanCurTime'))
            return
          }
          // 更改源
          if (this.oldMediaInfo.newType) {
            this.chooseSource(this.oldMediaInfo)
          } else {
            this.chooseSource(JSON.parse(dragElement.dataset.device))
          }
          this.selColor.name = 'yellow'
          this.selColor.value = 'rgb(255, 192, 0)'
          // 有夏令时并且选中的时间是夏令时重复
          if (this.DstTime.isDst && new Date(startDate).getTime() >= this.DstTime.secondDstDate.lastHour && new Date(startDate).getTime() < this.DstTime.secondDstDate.endTime) {
            // true落在左半格
            if (IsLeftHalf) {
              startDate = this.DstTime.secondDstDate.lastHour
              stopDate = this.DstTime.secondDstDate.startTime
            } else {
              startDate = this.DstTime.secondDstDate.startTime
              stopDate = this.DstTime.secondDstDate.endTime
            }
          }
          //  拿到离时间最近的一个事件
          const preEvent = this.getPreEvent(
            new Date(startDate).getTime(),
            new Date(stopDate).getTime()
          )
          if (preEvent) {
            const differ =
              new Date(stopDate).getTime() - new Date(startDate).getTime()
            startDate = preEvent.endTime
            stopDate = startDate + differ
          }
          // 判断是否是program模板
          if (programTemplate === 'programtemplate') {
            this.DragProgramTemplate({
              startTime: new Date(startDate),
              endTime: new Date(stopDate),
              event: JSON.parse(dragElement.dataset.device)
            })
          } else {
            this.ClickandDragCreate({
              startTime: new Date(startDate),
              endTime: new Date(stopDate),
              event: JSON.parse(dragElement.dataset.device)
            }, e, 1)
          }
        } else {
          this.DragTemlateDetail(JSON.parse(dragElement.dataset.device), e)
        }
      }
    },
    // 拖拽模板
    DragTemlateDetail (data, e) {
      const view = $('#calendar').fullCalendar('getView')
      const targetX = $('#calendar').offset().left
      let CreateStartTime
      let TimeList = []
      if (view.name == 'month') {
        return
      } else if (view.name == 'agendaWeek') {
        const timeEle = $('.fc-head-container .fc-day-header')
        timeEle.map((i, v) => {
          TimeList.push($(v).attr('data-date'))
          return 1
        })
        // 落下的位置距离日历边缘距离
        const distance = e.clientX - targetX - 39
        //  落下的第几天
        const index = Math.floor(
          distance / (($(e.target).width() - 2) / 7).toFixed(2)
        )
        // 判断是否是半个小时
        if (data.type == 2) {
          const time = $(e.target).parent().attr('data-time')
          CreateStartTime = new Date(`${TimeList[index]} ${time}`).getTime()
        } else {
          // 判断是周模板还是日模板
          CreateStartTime = data.scheduleType == 2 ? new Date(`${TimeList[index]} 00:00:00`).getTime() : new Date(`${TimeList[0]} 00:00:00`).getTime()
        }
      } else if (view.name == 'agendaDay') {
        const timeEle = $('.fc-day-header.fc-widget-header')
        TimeList = [timeEle.attr('data-date')]
        // 判断是否是半个小时
        if (data.type == 2) {
          const time = $(e.target).parent().attr('data-time')
          CreateStartTime = new Date(`${TimeList[0]} ${time}`).getTime()
        } else {
          CreateStartTime = new Date(`${TimeList[0]} 00:00:00`).getTime()
        }
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/checkTemplateConflict', {
        templateId: data.id,
        startTime: CreateStartTime,
        rid: this.selectR.peerId
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const param = {
              id: data.id,
              startTime: CreateStartTime,
              rid: this.selectR.peerId,
              coverEvent: false
            }
            if (!res.data.result) {
              this.$confirm('One Schedule item spans to the next day, do you wish to overwrite schedule conflict?', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: ''
              })
                .then(() => {
                  param.coverEvent = true
                  this.ApplicationTemplate(param)
                })
                .catch(() => {
                  this.ApplicationTemplate(param)
                })
            } else {
              this.ApplicationTemplate(param)
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        } else {
          this.$message({
            type: 'warning',
            message: this.$t('lang.serverFailed')
          })
        }
      }).catch()
    },
    // 调接口用模板创建事件
    ApplicationTemplate (param) {
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/template/userTemplate', param)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getBookingEventAccodT()
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.error(errorInfo)
            }
          } else {
            this.$message({
              type: 'warning',
              message: this.$t('lang.serverFailed')
            })
          }
        }).catch()
    },
    // 拖拽program模板
    DragProgramTemplate (data) {
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/event/addEventByTemplateId', {
          eventTemplateId: data.event.id,
          startTime: data.startTime.getTime(),
          receiverId: this.selectR.peerId
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getBookingEventAccodT()
            } else {
              const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch()
    },
    // 重新创建事件
    ClickandDragCreate (eventMessage, jsEvent, type) {
      // 先关闭弹出框
      this.EventMotion.switch = false
      // 计算弹出框位置
      this.SetFramePosition(jsEvent)
      // type 0 点击空白创建  1拖拽创建
      if (type) {
        if (['file', 'video'].includes(eventMessage.event.type.toLowerCase())) {
          this.createBooking({
            title: eventMessage.event.name,
            color: eventMessage.event.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
            tname: eventMessage.event.name,
            rname: this.selectR.name,
            tpeerid: eventMessage.event.sourceId,
            rpeerid: this.selectR.peerId,
            record: 0,
            startTime: eventMessage.startTime.getTime(),
            endTime: eventMessage.startTime.getTime() + Number(eventMessage.event.videoTimes) * 1000,
            ttype: eventMessage.event.type,
            scheduleType: 'live',
            sourceType: 0,
            duration: Number(eventMessage.event.videoTimes) * 1000
          })
        } else {
          this.createBooking({
            title: eventMessage.event.name,
            color: 'rgb(255, 192, 0)',
            tname: eventMessage.event.name,
            rname: this.selectR.name,
            tpeerid: eventMessage.event.peerId,
            rpeerid: this.selectR.peerId,
            record: 0,
            startTime: eventMessage.startTime.getTime(),
            endTime: eventMessage.endTime.getTime(),
            ttype: eventMessage.event.type,
            scheduleType: 'live',
            sourceType: 1,
            duration:
              eventMessage.endTime.getTime() - eventMessage.startTime.getTime()
          })
        }
      } else {
        // 禁止里层滚动条滚动
        $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'hidden')
        this.picthOnEvent = {
          startTime: eventMessage.startTime.getTime(),
          endTime: eventMessage.endTime.getTime(),
          tpeerid: '',
          //   新加子事件scte属性
          eventSegments: []
        }
        this.$nextTick(() => {
          this.EventMotion.motion = 2
          this.EventMotion.switch = true
        })
      }
    },
    // 编辑booking事件
    fillCreateBox (event, jsEvent, type) {
      // type  1是编辑 0是查看
      // 先关闭弹出框
      this.EventMotion.switch = false
      // 计算弹出框位置
      this.SetFramePosition(jsEvent)
      // 禁止里层滚动条滚动
      $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'hidden')

      this.curLiveStatus = null
      // 事件的一些信息
      const infoObj = event.eventData
      // 保存点击的事件id
      this.deleteId = event.id
      //  拿取对应的子事件
      const CurrentEvent = this.PageAllEvent.filter((item) => item.id == event.id)
      this.picthOnEvent = {
        id: event.id,
        title: infoObj.title,
        color: CurrentEvent[0].color,
        reporter: infoObj.reporter,
        description: infoObj.description,
        tname: infoObj.tname,
        rname: infoObj.rname,
        tpeerid: infoObj.tpeerid,
        rpeerid: infoObj.rpeerid,
        record: !!event.item.record,
        startTime: event.start._d.getTime(),
        endTime: event.end._d.getTime(),
        delay: infoObj.delay,
        bitrate: infoObj.bitrate,
        ttype: infoObj.type,
        eventId: event.id,
        duration: '',
        houseId: CurrentEvent[0].houseId,
        sourceType: CurrentEvent[0].sourceType,
        //   新加子事件scte属性
        eventSegments: CurrentEvent[0].eventSegments,
        liveStatus: CurrentEvent[0].liveStatus
      }
      // 拖拽编辑时时间已经发生变化
      if (type) {
        // 初始时间的变化
        const EventTimeChange =
          this.picthOnEvent.startTime - CurrentEvent[0].startTime
        // 变化子事件时间
        this.picthOnEvent.eventSegments.forEach((item, index) => {
          if (EventTimeChange) {
            item.timingIn = item.timingIn + EventTimeChange
            item.timingOut = item.timingOut + EventTimeChange
          }
        })
      }
      this.$nextTick(() => {
        this.EventMotion.motion = type ? 1 : 0
        this.EventMotion.switch = true
      })
    },
    // 关闭创建box
    closeCreateBox () {
      // 事件挪动位置的回归
      if (this.dragEvent.id) {
        $('#calendar').fullCalendar('removeEvents')
        $('#calendar').fullCalendar('renderEvents', this.events, true)
        this.dragEvent = {}
      }

      $('#calendar').fullCalendar('unselect') // 清空选中区域
      $('.fc-scroller.fc-time-grid-container').css('overflow-y', 'scroll') // 开启里层滚动条滚动
      // 初始化数据
      this.initEventData()
    },
    OperationSuccess (data) {
      this.closeCreateBox() // 关闭弹窗
      if (data.type == 'delete') {
        let Sindex = 0
        this.MockData.forEach((item, index) => {
          if (item.id == data.eventDetail.id) {
            Sindex = index
          }
        })
        this.MockData.splice(Sindex, 1)
      } else if (data.type == 'create') {
        data.eventDetail.id = new Date().getTime()
        data.eventDetail.eventId = data.eventDetail.id
        data.eventDetail.ttype = ''
        data.eventDetail.color = 'rgb(255, 255, 255)'
        data.eventDetail.eventSegments = []
        this.MockData.push(data.eventDetail)
      } else if (data.type == 'save') {
        let Sindex = 0
        this.MockData.forEach((item, index) => {
          if (item.id == data.eventDetail.id) {
            Sindex = index
          }
        })
        this.MockData.splice(Sindex, 1)
        this.MockData.push(data.eventDetail)
      }
      // 删除成功后刷新列表
      this.getBookingEventAccodT()
    },
    // 关闭创建框初始化数据
    initEventData () {
      this.EventMotion.switch = false
      this.editStatus = {}
    },
    // 发送请求创建booking
    createBooking (param) {
      if (!param.title.trim() && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      param.id = new Date().getTime()
      param.eventId = param.id
      this.MockData.push(param)
      this.closeCreateBox() // 关闭弹窗
      // 删除成功后刷新列表
      this.getBookingEventAccodT()
    },
    // 窗口大小调整
    handleResize () {
      // this.calendarFlag = false;
      // this.calendarConfig.contentHeight = document.body.offsetHeight - 190;
      this.EventMotion.switch = false
      if (document.body.clientWidth > 1024) {
        this.isShow.rList = true
        this.isShow.sourceList = true
        this.calendar.searchS = false
        this.calendar.searchR = false
      } else {
        this.isShow.rList = false
        this.isShow.sourceList = false
        this.calendar.searchS = true
        this.calendar.searchR = true
      }
      // this.$nextTick(() => {
      //     this.calendarFlag = true;
      // })
      this.initScroll()
    },
    // 注册滚动事件
    initScroll () {
      if (this.timer.refetchEvent) {
        clearTimeout(this.timer.refetchEvent)
        this.timer.refetchEvent = null
      }
      // 取消监听
      $('.magnifying .body').off('scroll')
      $('.fc-scroller.fc-time-grid-container').off('scroll')

      // 两边滚动一样
      this.$nextTick(() => {
        this.calendarHeight = $('.fc-view-container .fc-slats tbody').height()
        let scrollTopLeft = 0
        let scrollTopRight = 0

        scrollTopRight = $('.fc-scroller.fc-time-grid-container').scrollTop()
        $('.magnifying .body').scrollTop(scrollTopRight)

        $('.fc-scroller.fc-time-grid-container').scroll((event) => {
          scrollTopRight = $('.fc-scroller.fc-time-grid-container').scrollTop()
          if (scrollTopRight !== scrollTopLeft) {
            $('.magnifying .body').scrollTop(scrollTopRight)
          }
        })
        $('.magnifying .body').scroll((event) => {
          scrollTopLeft = $('.magnifying .body').scrollTop()
          if (scrollTopRight !== scrollTopLeft) {
            $('.fc-scroller.fc-time-grid-container').scrollTop(scrollTopLeft)
          }
        })
        // 默认滚动到当前时间
        const today = new Date()
        $('.fc-scroller.fc-time-grid-container').scrollTop(
          today.getHours() * 301
        )

        $('.magnifying .header').css(
          'height',
          $('.fc-widget-header th.fc-widget-header').height() + 2
        )
        this.dragToCreateEvent()
      })
    },
    handleCreBoxRScroll () {
      // 创建框中滚动到底部处理事件
      this.sourcePar.pageNum = this.lastSourcePageNum
      if (this.totalPage.source < this.sourcePar.pageNum) {
        return
      }
      this.sourcePar.pageNum++
      this.lastSourcePageNum = this.sourcePar.pageNum
      this.getSourceList('createSourceList')
    },
    // 切换输入框
    changeActiveStatus (curKey, value) {
      for (const key in this.heavyLoadObj.active) {
        if (key == curKey) {
          this.heavyLoadObj.active[key] = value
        } else {
          this.heavyLoadObj.active[key] = false
        }
      }
    },
    // 判断事件状态
    eventStatus (eventId) {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/getEventById'),
        data: { eventId },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const { result } = res.data
            if (result.liveStatus == 1 || result.liveStatus == 5) {
            // running
              if (result.liveStatus == 1) {
                this.isShow.deleteBtn = false
              }
              this.curLiveStatus = result.liveStatus
              this.EventMotion.motion = 0
              this.EventMotion.switch = true
            } else if (result.liveStatus === 2 || result.liveStatus === 4) {
            // this.removeCalendarEvent(eventId)
              this.EventMotion.motion = 0
              this.EventMotion.switch = true
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch()
    },
    // 移除已经结束的事件
    removeCalendarEvent (eventId) {
      $('#calendar').fullCalendar('removeEvents', eventId)
      this.$message.error(this.$t('lang.invalidEvent'))
    },
    // 计算弹出框位置
    SetFramePosition (jsEvent) {
      const ClickEvent = jsEvent || window.event
      const calendarLeft =
        document.getElementsByClassName('calendarLeft')[0].clientWidth +
        document.getElementsByClassName('magnifying')[0].clientWidth
      const calendarRight = document.getElementById('calendar')
      const calendarRightTop = calendarRight.getBoundingClientRect().top
      const FramePosition = {
        top: ClickEvent.clientY - calendarRightTop,
        left: ClickEvent.clientX - calendarLeft,
        bottom: calendarRight.clientHeight - ClickEvent.clientY + calendarRightTop,
        right: calendarRight.clientWidth - ClickEvent.clientX + calendarLeft
      }
      if (FramePosition.bottom >= 400 && FramePosition.right >= 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = true
        this.createBox.aleft = true
      } else if (FramePosition.bottom < 400 && FramePosition.right >= 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = false
        this.createBox.aleft = true
      } else if (FramePosition.bottom >= 400 && FramePosition.right < 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = true
        this.createBox.aleft = false
      } else {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = false
        this.createBox.aleft = false
      }
      this.createBox.top = this.createBox.top
      this.createBox.left = this.createBox.left
    },
    initSourcePar (val) {
      this.sourcePar.pack = val
      this.sourcePar.anywhere = val
      this.sourcePar.gridPack = val
      this.sourcePar.gridSdi = val
      this.sourcePar.ext = val
      this.sourcePar.token = val
      this.sourcePar.scte = val
    },
    // 获取日历时间title更改自己的title
    changeCalTitle () {
      var title = $('.fc-center h2').html()
      $('.replace_title').html(title)
      if (this.DstTime.isDst) {
        const timeEle = $('.fc-head-container .fc-day-header')
        const timeArr = []
        timeEle.map((i, v) => {
          timeArr.push($(v).attr('data-date'))
          return 1
        })
        // 夏令时开始
        const DstStart = Outil.changeNewDate(this.DstTime.firstDstDate.tmpDate.getTime())
        const indexStart = timeArr.indexOf(DstStart)
        if (timeArr.length > 0 && indexStart != -1) {
          $('.fc-head-container .fc-day-header').eq(indexStart).children('.Daylightstarts').remove()
          const Daylightstarts = '<div class="Daylightstarts" style="background: #068043;">Daylight Saving Time starts</div>'
          $('.fc-head-container .fc-day-header').eq(indexStart).append(Daylightstarts)
        }
        // 夏令时结束
        const DstEnd = Outil.changeNewDate(this.DstTime.secondDstDate.tmpDate.getTime())
        const indexEnd = timeArr.indexOf(DstEnd)
        if (timeArr.length > 0 && indexEnd != -1) {
          $('.fc-head-container .fc-day-header').eq(indexEnd).children('.Daylightends').remove()
          const Daylightends = '<div class="Daylightends" style="background: #068043;">Daylight Saving Time ends</div>'
          $('.fc-head-container .fc-day-header').eq(indexEnd).append(Daylightends)
        }
      }
    },
    preDate () {
      // 上一视图日历
      playoutAnalyze(`${googleKey}DatePreClick`, '/po')
      $('#calendar').fullCalendar('prev')
      this.changeCalTitle()
      this.getBookingEventAccodT()
      // 删除月视图的日期
      this.DeleteMonthDate()
      this.LeftNavDate()
    },
    nextDate () {
      // 下一视图日历
      playoutAnalyze(`${googleKey}DateNextClick`, '/po')
      $('#calendar').fullCalendar('next')
      this.changeCalTitle()
      this.getBookingEventAccodT()
      // 删除月视图的日期
      this.DeleteMonthDate()
      this.LeftNavDate()
    },
    // 左边换大写
    LeftNavDate () {
      const arr1 = $('.fc-slats .fc-widget-content span')
      $.each(arr1, (index, item) => {
        $(item).html($(item).html().toUpperCase())
      })
    },
    refreshEvents () {
      this.$refs.calendar.$emit('refetch-events')
    },
    eventSelected (event) {
      console.log('select')
      this.selected = event
    },
    eventCreated () {
      this.config.selectable = false
    },
    dayClick (event, jsEvent, view) {
      jsEvent.stopPropagation()
    },
    // 显示对应的元素
    showEle (keyVal) {
      if (keyVal == 'filterBox') {
        playoutAnalyze(`${googleKey}CalendarFilterIconClick`, '/po')
        if (document.body.clientWidth <= 1024) {
          this.isShow.sourceList = false
        }
      }
      if (keyVal == 'searchS') {
        playoutAnalyze(`${googleKey}SourceConditionClick`, '/po')
      }
      if (keyVal == 'searchR') {
        playoutAnalyze(`${googleKey}RConditionClick`, '/po')
      }
      for (var key in this.calendar) {
        if (keyVal == key) {
          this.calendar[key] = !this.calendar[key]
        } else {
          this.calendar[key] = false
        }
      }
      if (document.body.clientWidth <= 1024) {
        this.calendar.searchS = true
        this.calendar.searchR = true
      }
      this.sourcePar.condition = this.lastSourceCondition
        ? this.lastSourceCondition
        : ''
      this.rPar.condition = ''
    },
    // 获取source列表
    getSourceList (createSourceList) {
      if (this.lastCondition.source != this.sourcePar.condition) {
        // 搜索条件更改时
        this.lastCondition.source = this.sourcePar.condition
        this.sourcePar.pageNum = 1
        // this.lastLeftRPageNum = 1;
      }
      if (this.totalPage.source < this.sourcePar.pageNum) {
        // 搜索的页面不能超过总页数
        return
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl(`/event/listSource/${this.$BehaviorSyns.getProgramId()}`),
        data: this.sourcePar,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            // this.totalPage.source = res.data.result.pages || 1;
            const { result } = res.data
            if (
              !result.scteList ||
            result.deviceList.result.pages > result.scteList.pages
            ) {
              this.totalPage.source = result.deviceList.result.pages || 1
            } else {
              this.totalPage.source = result.scteList.pages || 1
            }
            if (result.scteList && result.scteList.list) {
              result.scteList.list.forEach((v) => {
                v.name = v.nickName
                v.peerId = v.id
              })
            }
            const scteList = (result.scteList && result.scteList.list) || []
            const dateList = result.deviceList.result.list.concat(scteList)
            if (this.sourcePar.pageNum == 1) {
              this[createSourceList] = dateList
            } else {
              dateList.forEach((v, i) => {
                this[createSourceList].push(v)
              })
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      })
    },
    // 选择source
    // selR(itm, index) {
    selectSourceItem (itm, index) {
      this.event.source = itm.name
      this.event.tpeerid = itm.peerId
      this.event.videoUrls = itm.videoUrls
      this.selectSource = itm
      this.sourceType = itm.type.toLowerCase()
      this.event.prerollTime = itm.prerollTime
      this.event.duration = itm.duration
      this.event.ttype = itm.type.toLowerCase()
      // if (this.sourceType.toLowerCase() == 'scte' || this.sourceType.toLowerCase() == 'video') {
      if (['scte', 'video', 'file'].includes(this.sourceType.toLowerCase())) {
        const durationTime = itm.duration || itm.videoTimes
        this.endDate = new Date(
          this.createStartTime.getTime() + durationTime * 1000
        )
        this.createStopTime = this.endDate
      } else {
        this.endDate = new Date(
          this.createStartTime.getTime() + 30 * 60 * 1000
        )
        this.createStopTime = this.endDate
      }
      Bus.$emit('changeSource', {
        type: itm.type.toLowerCase(),
        tpeerId: itm.peerId
      })
    },
    // 放大日历表
    openCalendar (index, type) {
      console.log('放大日历表')
      // playoutAnalyze(`bookingZoomOpen`, '/po');
      // index=0;
      this.closeCreateBox()
      const view = $('#calendar').fullCalendar('getView')
      if (!['agendaWeek', 'agendaDay'].includes(view.name)) {
        this.$message.error(this.$t('lang.switchToWeek'))
        return
      }
      this.transformTime(index * 30)
      this.dateInfo.show = true
    },
    // 转换时间
    transformTime (time) {
      this.dateInfo.date.date = []
      const timeEle = $('.fc-head-container .fc-day-header')
      const timeArr = []
      timeEle.map((i, v) => {
        timeArr.push($(v).attr('data-date'))
        // this.dateInfo.date.weekTitle.push($(v).find('a').html());
        return 1
      })
      this.dateInfo.date.date = timeArr
      // let endTime = time + 30;
      const endTime = time + 60
      const start = `${Math.floor(time / 60) > 9 ? '' : '0'}${Math.floor(
        time / 60
      )}:${time % 60 > 9 ? '' : '0'}${time % 60}`
      const end = `${Math.floor(endTime / 60)}:${endTime % 60}`
      this.dateInfo.date.start = start
      this.dateInfo.date.end = end
    },
    // 选择源
    chooseSource (item) {
      console.log('选择源')
      this.selectSource = JSON.parse(JSON.stringify(item))
      item.peerId = item.peerId || item.id
      this.creating = false // 隐藏创建booking信息展示
      this.rPar.tpeerId = item.peerId // 更改获取R列表的参数T的peerId
      this.rPar = JSON.parse(JSON.stringify(this.rPar))
      this.rPar.pageNum = 1
    },
    // 选择R
    currentSelectData (item) {
      this.selectR = item
      this.currentSelectPeerid = item.peerId
      this.EventMotion.switch = false
      this.getBookingEventAccodT()
      this.closeCreateBox()
    },
    // close down list
    closeDownList () {
      this.isShow.showColorOpt = false
    },
    // show color box option
    showColorOpt () {
      this.isShow.showColorOpt = !this.isShow.showColorOpt
      const googleAnalyzeEvent = `${googleKey}EventColorOpen`
      if (!this.isShow.showColorOpt) return
      playoutAnalyze(googleAnalyzeEvent, '/po')
    },
    prevent (e) {
      e.stopPropagation()
      this.isShow.createBoxSourceList = false
    },
    showWeekFirstDay () {
      console.log('选择周')
      var nowTemp = new Date() // 当前时间
      var oneDayLong = 246060 * 1000 // 一天的毫秒数
      var c_time = nowTemp.getTime() // 当前时间的毫秒时间
      var c_day = nowTemp.getDay() || 7 // 当前时间的星期几
      var m_time = c_time - (c_day - 1) * oneDayLong // 当前周一的毫秒时间
      var monday = new Date(m_time) // 设置周一时间对象
      var m_year = monday.getFullYear()
      var m_month = monday.getMonth() + 1
      var m_date = monday.getDate()
      return `${m_year}-${m_month}-${m_date} 00:00:00` // 周一的年月日
    },
    // 跳转日期
    changeDateView (date) {
      $('#calendar').fullCalendar('gotoDate', date)
      this.getBookingEventAccodT()
    },
    // 循环遍历bookmark的值
    getBookmarkChooseVal (arr) {
      if (arr.length == 0) return
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].check) this.bookmarkArr.push(arr[i].id)
        if (arr[i].children.length > 0) {
          this.getBookmarkChooseVal(arr[i].children)
        }
      }
    },
    // 切换显示bookmark
    switchShowBF () {
      if (!this.isShow.bookmark) {
        playoutAnalyze(`${googleKey}BookmarkClick`, '/po')
      } else {
        playoutAnalyze(`${googleKey}filterClick`, '/po')
      }
      this.isShow.bookmark = !this.isShow.bookmark
    },
    // 获取与T相关的预约事件  获取事件列表
    getBookingEventAccodT () {
      const res = JSON.parse(JSON.stringify(this.MockData))
      this.MockData.forEach(item => {
        const eventSegments = {
          segmentId: 1,
          segmentOrder: 0,
          timingIn: item.startTime,
          timingOut: item.endTime
        }
        item.eventSegments = [eventSegments]
      })
      localStorage.setItem('WelcomeEvent', JSON.stringify(this.MockData))
      // 存一下所有事件
      this.PageAllEvent = res

      if (this.timer.countDown) {
        clearInterval(this.timer.countDown)
        this.timer.countDown = null
        this.countDownTime = '00:00:00'
      }
      $('#calendar').fullCalendar('removeEvents') // 先清空表格
      this.events = []
      const eventDatas = []
      const data = res
      data.forEach((item, idx) => {
        // 过去的事件不再执行
        item.parameters = item.parameters
          ? JSON.parse(item.parameters)
          : {}
        item.source = item.source ? JSON.parse(item.source) : {}
        let bgColor = item.color || 'rgb(255, 192, 0)'

        const eventData = {
          description: item.description || '',
          reporter: item.parameters.reporter || '',
          title: item.title,
          tname: item.tname,
          rname: item.rname,
          tpeerid: item.tpeerid,
          rpeerid: item.rpeerid,
          type: item.ttype,
          delay: item.parameters.delay || '',
          bitrate: item.parameters.bitrate || '',
          url: (item.source && item.source.url) || '',
          // spliceType: item.scte ? item.scte.spliceType : '',
          duration: item.scte ? item.scte.duration : '',
          videoTimes: ['file', 'video'].includes(item.ttype.toLowerCase())
            ? (item.endTime - item.startTime) / 1000
            : '',
          prerollTime: item.scte ? item.scte.prerollTime : '',
          email: item.email,
          userId: item.userId
        }
        const colorName = this.mateColor(bgColor)
        if (item.liveStatus == 1) {
          // 正在执行的事件为green
          bgColor = 'rgb(15, 190, 113)'
          // item.color = 'rgb(15, 190, 113)'
        }
        if (item.liveStatus == 2) {
          bgColor = '#777777'
          // item.color = '#777777'
        }
        // 是否执行失败
        let IsOnFailure = false
        if (item.liveStatus == 4 || item.liveStatus == 5 || item.liveStatus == 6) {
          bgColor = '#8A4B4B'
          // item.color = '#8A4B4B'
          IsOnFailure = true
        }
        const startTime = this.transitionHourly(new Date(item.startTime))
        const endTime = this.transitionHourly(new Date(item.endTime))
        // 判断是否有夏令时
        let isDst = false
        if (this.DstTime.isDst) {
          // 修改夏令时事件的样式
          if ((item.startTime >= this.DstTime.secondDstDate.lastHour && item.startTime < this.DstTime.secondDstDate.startTime) && (item.endTime >= this.DstTime.secondDstDate.startTime && item.endTime < this.DstTime.secondDstDate.endTime)) {
            isDst = true
            // console.log()
          }
        }
        const eventInfo = {
          id: item.eventId,
          item,
          eventData,
          title: `${startTime} - ${endTime} ${item.title}`,
          start: $.fullCalendar.moment(item.startTime),
          end: $.fullCalendar.moment(item.endTime),
          // start: '2021-11-07T:30:00Z',
          // end: item.endTime,
          backgroundColor: bgColor,
          colorName,
          borderColor: 'transparent',
          // url: `${item.eventId}`,
          className: `livestatus-${item.liveStatus} ${item.eventId} copy_icon`,
          startTime: item.startTime,
          endTime: item.endTime,
          liveStatus: item.liveStatus,
          email: item.email,
          userId: item.userId,
          copy: item.copy
        }
        if (isDst) {
          // 分两段添加
          const eventInfoStart = JSON.parse(JSON.stringify(eventInfo))
          eventInfoStart.start = $.fullCalendar.moment(item.startTime)
          eventInfoStart.end = $.fullCalendar.moment(this.DstTime.secondDstDate.startTime - 1)
          eventDatas.push(eventInfoStart)

          // const eventInfoEnd = JSON.parse(JSON.stringify(eventInfo))
          // eventInfoEnd.start = $.fullCalendar.moment(this.DstTime.secondDstDate.startTime)
          // eventInfoEnd.end = $.fullCalendar.moment(item.endTime)
          // eventInfoEnd.isDst = true
          // eventDatas.push(eventInfoEnd)
        } else {
          // 执行失败的事件使用执行结束显示事件
          if (IsOnFailure && item.executeStartTime != item.executeEndTime) {
            eventInfo.start = $.fullCalendar.moment(item.executeStartTime)
            eventInfo.end = $.fullCalendar.moment(item.executeEndTime)
          } else if (IsOnFailure && item.executeStartTime == item.executeEndTime) {
            return
          }
          eventDatas.push(eventInfo)
        }
        // $('#calendar').fullCalendar('renderEvent', eventInfo, true);        //渲染到表格
      })
      eventDatas.sort((a, b) =>
        // 按开始时间进行排序
        a.startTime - b.startTime
      )
      const currentTime = new Date().getTime()
      // for (const v of eventDatas) {
      //   if (v.liveStatus != 1 && v.liveStatus != 5 && v.startTime >= currentTime) {
      //     // 找到第一个未执行的事件
      //     if (!(v.backgroundColor === 'rgb(255, 255, 255)' && !v.eventData.tpeerid)) {
      //       v.backgroundColor = 'rgb(255, 255, 0)'
      //     }
      //     this.countDownTime = Outil.getIntervalTime(new Date(), v.startTime)
      //     this.nextEvent.rname = v.eventData.rname
      //     this.nextEvent.tname = v.eventData.tname
      //     this.nextEvent.eventName = v.eventData.title
      //   }
      // }
      this.events = eventDatas
      this.events.reverse()
      $('#calendar').fullCalendar('renderEvents', this.events, true)
      // 添加DR图标
      this.AddDRicon()
      this.registerDrag()
    },
    // 分按月按周按日分别查询
    async partGetEventAccodT () {
      try {
        const Timetype = $('#calendar').fullCalendar('getView').name
        let EventList = [] // 事件列表
        const getCurrenTime = this.getCurrenTime()
        if (Timetype == 'agendaWeek') {
          // const _this = this
          const time = getCurrenTime.map((item) => new Date(`${item} 00:00:00`).getTime())
          await this.axios
            .all([
              this.GetEventQuest(time[0], time[1] - 1, 3),
              this.GetEventQuest(time[1], time[2] - 1, 1),
              this.GetEventQuest(time[2], time[3] - 1, 1),
              this.GetEventQuest(time[3], time[4] - 1, 1),
              this.GetEventQuest(time[4], time[5] - 1, 1),
              this.GetEventQuest(time[5], time[6] - 1, 1),
              this.GetEventQuest(
                time[6],
                time[6] + 24 * 60 * 60 * 1000 - 1,
                1
              )
            ])
            .then(
              this.axios.spread((res1, res2, res3, res4, res5, res6, res7) => {
                EventList = EventList.concat(
                  res1.data.result,
                  res2.data.result,
                  res3.data.result,
                  res4.data.result,
                  res5.data.result,
                  res6.data.result,
                  res7.data.result
                )
              })
            )
        } else if (Timetype == 'agendaDay') {
          const time = new Date(`${getCurrenTime[0]} 00:00:00`).getTime()
          await this.GetEventQuest(time, time + 24 * 60 * 60 * 1000).then(
            (res) => {
              EventList = EventList.concat(res.data.result)
            }
          )
        } else {
          await this.GetEventQuest('1627810860000', '15015547523410').then((res) => {
            EventList = EventList.concat(res.data.result)
          })
        }
        return EventList
      } catch (error) {
        console.log(error)
        this.$message.error(this.$t('lang.internetOffline'))
        return []
      }
    },
    // 获取事件请求
    GetEventQuest (startTime, endTime, type) {
      // type=0   notCareStart=false notCareEnd=false
      // type=1   notCareStart=false notCareEnd=true
      // type=2   notCareStart=true notCareEnd=false
      // type=3   notCareStart=true notCareEnd=true
      var param = {
        // tId: tId || this.sourceId,
        tid: '',
        rids: [this.selectR.peerId],
        // rIds: '',
        startDate: startTime,
        endDate: endTime
      }
      if (type == 1) {
        param.notCareEnd = true
      } else if (type == 2) {
        param.notCareStart = true
      } else if (type == 3) {
        param.notCareStart = true
        param.notCareEnd = true
      }
      return this.axios({
        method: 'post',
        url: Outil.getUrl('/event/listEventByTR'),
        data: param,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          isCancelToken: true
        }
      })
    },
    // 计算样式
    computedStyle (item, parentItem) {
      const EventHeight = $(`.${parentItem.id}`).height()
      const meanHeight =
        EventHeight / (parentItem.endTime - parentItem.startTime)

      const ScteTop = Math.floor(
        (item.timingIn - parentItem.startTime) * meanHeight
      )

      const ScteHeight = Math.floor(
        (item.timingOut - item.timingIn) * meanHeight
      )
      if (item.segmentId == 5) {
        return `height: ${ScteHeight}px;top: ${ScteTop}px;background-color: #388BE5`
      } else if (item.segmentId == 10) {
        return `height: ${ScteHeight}px;top: ${ScteTop}px;background-color: #DA6F17`
      }
      return `height: ${ScteHeight}px;top: ${ScteTop}px`
    },
    // 插入子事件
    InsertionScte (item) {
      if (item.eventSegments.length > 0) {
        const ScteList = item.eventSegments
        let ScteElementWrap = '<div class="ScteListWrap">'
        for (const key in ScteList) {
          if (ScteList[key].segmentId != 1) {
            const computedStyle = this.computedStyle(ScteList[key], item)
            const ScteWrap = ` <div class="ScteWrap" style="${computedStyle}">
                            </div>`
            ScteElementWrap = ScteElementWrap + ScteWrap
          }
        }
        ScteElementWrap = `${ScteElementWrap}</div>`
        if ($(`.${item.id}`).length == 1) {
          $(`.${item.id}`).prepend(ScteElementWrap)
        } else {
          // 后续有时间会对重复的进行其他操作
          $(`.${item.id}`).eq(0).prepend(ScteElementWrap)
        }
      }
    },
    // 添加D,R图标 紫色加边框，插入scte
    AddDRicon () {
      // 获取什么视图
      const Timetype = $('#calendar').fullCalendar('getView').name
      this.PageAllEvent.forEach((item) => {
        item.backgroundColor = item.color ? item.color : 'rgb(255, 192, 0)'
        // 插入scte
        if (Timetype == 'agendaDay' || Timetype == 'agendaWeek') {
          this.InsertionScte(item)
        }
        if (Timetype == 'agendaDay') {
          $(`.${item.id} .fc-content .fc-title .iconfontWrap`).remove()
          $(`.${item.id} .fc-content .fc-title`).prepend(
            `<div class='iconfontWrap' style=\"position: absolute;right: 0;top: 0; display:flex;padding-right:3px\"></div>
            <div class='HouseID' style=\"position:absolute;top:0px;left:45%\">House ID:${item.houseId ? item.houseId : ''}</div>`
          )
          // 绑定点击事件
          this.monitorClickIcon(
            $(`.${item.id}  ‘.fc-content .fc-title .iconfontWrap`)
          )
          // 判断哪些图标需要
          const iconElement = this.judgeIconNeed(item)
          $(`.${item.id} .fc-content .fc-title .iconfontWrap`).prepend(
            iconElement
          )
        } else {
          // 绑定hover事件
          this.monitorHoverEvent($(`.${item.id}`), item)
        }
        // 判断是否有夏令时
        if (this.DstTime.isDst) {
          // 修改夏令时事件的样式
          if ((item.startTime >= this.DstTime.secondDstDate.lastHour && item.startTime < this.DstTime.secondDstDate.endTime) || (item.endTime >= this.DstTime.secondDstDate.lastHour && item.endTime <= this.DstTime.secondDstDate.endTime)) {
            if (item.startTime < this.DstTime.secondDstDate.startTime) {
              $(`.${item.id}`).css({ width: '50%', left: '0%' })
            } else {
              $(`.${item.id}`).css({ width: '50%', left: '50%' })
            }
          }
        }
        if (item.backgroundColor == 'rgb(146, 72, 199)') {
          //  紫色事件加边框
          // let borderHeight= $(`.${item.id}`).css('height')
          //   $(`.${item.id}`).prepend(
          //     `<p class="addBorder" style="box-sizing: border-box;position:absolute;top:0px;right:0px;border:2px solid red;border-left:transparent;height:${borderHeight};width:15px"></p>`
          //   )
          // 紫色事件加进出箭头
          // $(`.${item.id}`).addClass('purpleEvent')
        }
      })
    },
    // 判断哪些图标需要
    judgeIconNeed (item) {
      let DIconElement = ''
      let CCIconElement = ''
      let RIconElement = ''
      let SIconElement = ''
      if (typeof item == 'object') {
        // D图标
        if (item.copy == 'true') {
          DIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#67AA25'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                                <i class='iconfont icon-duplicate1' style="font-size:12px;transform:scale(.8)"></i>
                              </p>
                              `
        }
        // cc图标
        CCIconElement = `<p style="width:20px;height:20px;background:#AAAAAA;text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                            <i class='iconfont icon-cc' style="font-size:10px;transform:scale(.7)"></i>
                          </p>
                              `
        //  R图标
        if (item.record) {
          RIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#EC5050'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-secondaryrecord' style="font-size:12px"></i>
              </p>
              `
        } else {
          RIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#EC5050'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-secondaryrecordoff' style="font-size:12px"></i>
              </p>
              `
        }
        // s图标
        SIconElement = `<p style="width:20px;height:20px;background:${(item.liveStatus == 2 || item.liveStatus == 4) ? '#AAAAAA' : '#F2F2F2'};text-align:center;line-height:20px;margin:0px 2px 0px 0px;border-radius: 3px;">
                <i class='iconfont icon-SCTEoff' style="font-size:12px"></i>
              </p>
              `
        return DIconElement + CCIconElement + RIconElement + SIconElement
      } else {
        return ''
      }
    },
    // 监听图标点击事件
    monitorClickIcon (item) {
      item.click((event) => {
        this.IsClickIcon = true
      })
    },
    // 监听hover事件
    monitorHoverEvent (element, item) {
      element.hover((event) => {
        // 鼠标进入事件
        if (event.type == 'mouseenter') {
          const IconElement = this.judgeIconNeed(item)
          const BoxPosition = {
            top: event.clientY,
            left: event.clientX,
            bottom: document.documentElement.clientHeight - event.clientY,
            right: document.documentElement.clientWidth - event.clientX
          }
          let PositionClass = ''
          if (BoxPosition.top < 300) {
            PositionClass = ' eventActiveBoxBottom'
          }
          if (BoxPosition.right < 250) {
            PositionClass = `${PositionClass} eventActiveBoxRight`
          }
          const DomElement = `
                <div class="eventActiveBox${PositionClass}">
                  <div class="eventMessageBox" style="background:${item.backgroundColor}">
                    <p class="eventMessageTitle">${item.title}</p>
                    <div class='iconfontWrap'>
                      ${IconElement}
                    </div>
                  </div>
                    <i class="el-icon-caret-bottom" style='color:${item.backgroundColor};'></i>
                    <i class="el-icon-caret-top" style='color:${item.backgroundColor};'></i>
                </div>
                `
          element.css('z-index', 2)
          element.prepend(DomElement)
          // 绑定点击事件
          this.monitorClickIcon(element.find('.eventActiveBox .iconfontWrap'))
        } else {
          //  鼠标离开事件
          element.css('z-index', 1)
          element.children('.eventActiveBox') &&
            element.children('.eventActiveBox').remove()
        }
      })
    },
    getCurrenTime () {
      const timeEle = $('.fc-head-container .fc-day-header')
      const timeArr = []
      timeEle.map((i, v) => {
        timeArr.push($(v).attr('data-date'))
        return 1
      })
      return timeArr
    },
    // 找到color对应的颜色或值
    mateColor (color) {
      const colorObj = {
        green: 'rgb(15, 190, 113)',
        skyblue: 'rgb(70, 201, 225)',
        blue: 'rgb(14,107,209)',
        orange: 'rgb(255, 197, 115)',
        pink: 'rgb(255, 106, 146)',
        yellow: 'rgb(255, 192, 0)',
        purple: 'rgb(146, 72, 199)'
      }
      for (const key in colorObj) {
        if (color == key) {
          return colorObj[key]
        }
        if (color == colorObj[key]) {
          return key
        }
      }
    },
    // 转换splice type
    transformSpliceType (val) {
      let type
      switch (val) {
        case '0':
          type = 'Start Normal'
          break
        case '1':
          type = 'Start Immediate'
          break
        case '2':
          type = 'End Normal'
          break
        case '3':
          type = 'End Immediate'
          break
        case '4':
          type = 'Cancel'
          break
        default:
          break
      }
      return type
    },
    // 小屏下切换source列表是否显示
    toggleSource (e) {
      if (document.body.clientWidth > 1024) {
        return
      }
      e.stopPropagation()
      this.isShow.sourceList = !this.isShow.sourceList
    },
    // 小屏下切换r列表是否显示
    toggleR (e) {
      if (document.body.clientWidth > 1024) {
        return
      }
      e.stopPropagation()
      this.isShow.rList = !this.isShow.rList
    },
    todayDate () {
      const nowDate = new Date()
      const year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1
      let day = nowDate.getDate()
      if (month < 10) month = `0${month}`
      if (day < 10) day = `0${day}`
      return `${year}-${month}-${day}`
    }
  },
  computed: {
    // 视图切换按钮
    // viewBtns() {
    //     return
    // },
    // 日历渲染
    eventSources () {
      const self = this
      return [
        {
          events (start, end, timezone, callback) {
            self.$nextTick(() => {
              callback(self.events.filter((v) => 0))
            })
          }
        }
      ]
    },
    // 计算source列表高度
    sListBoxHeight () {
      if (this.calendar.searchS) {
        return 'calc(100% - 100px)'
      }
      if (this.calendar.filterBox) {
        return 'calc(100% - 410px)'
      }
      return 'calc(100% - 50px)'
    },
    // 计算r列表高度
    rListBoxHeight () {
      if (this.calendar.searchR) {
        return 'calc(100% - 100px)'
      }
      return 'calc(100% - 50px)'
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    Bus.$off('leftListUpdate', this.registerDrag)
    Bus.$off('BehaviorChange')
  }
}
</script>
<style lang='less' scoped>
@import '~fullcalendar/dist/fullcalendar.css';
.MouseRightClick {
  position: fixed;
  background: #252525;
  z-index: 20000;
  padding: 10px 20px;
  width: 110px;
  cursor: pointer;
  .operation {
    width: 70px;
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
}
.CreateTemplate {
  float: right;
  width: calc(100% - 435px);
  margin-top: -13px;
}
.ProgramTemplateEdit {
  float: right;
  width: calc(100% - 435px);
  height: 100%;
}
.el-dialog {
  width: 30%;
}
p {
  margin: 0;
}
input {
  outline: none;
}
.forbid /deep/ .el-input__inner {
  cursor: not-allowed;
}
// ::-webkit-scrollbar {
//   /*滚动条整体样式*/
//   width: 0; /*高宽分别对应横竖滚动条的尺寸*/
// }
// ::-webkit-scrollbar-thumb {
//   /*滚动条里面小方块*/
//   border-radius: 5px;
//   background-color: rgb(233, 233, 233);
//   opacity: 0.7;
// }
// ::-webkit-scrollbar-track {
//   /*滚动条里面轨道*/
//   border-radius: 5px;
//   background: none;
// }
.show_height {
  height: 170px;
}
ul {
  margin-bottom: 0;
}
.green {
  border: 1px solid #0a9a5a;
  background: #0fbe71;
}
.skyblue {
  background-color: #46c9e1;
  border: 1px solid #0ca595;
}
.blue {
  background-color: #2f8df4;
  border: 1px solid #126ed3;
}
.orange {
  background-color: #ffc573;
  border: 1px solid #d8a966;
}
.pink {
  background-color: #ff6a92;
  border: 1px solid #ee3656;
}
.yellow {
  background-color: #ffc000;
  border: 1px solid #ffc000;
}
.purple {
  background-color: #9248c7;
  border: 1px solid #9248c7;
}
.calendar {
  height: 850px;
  background: #444;
  overflow: hidden;
  .gray {
    color: #666 !important;
    input {
      color: #666 !important;
    }
  }
  .calendarLeft {
    width: 435px;
    height: 850px;
    overflow: hidden;
    float: left;
  }
  .magnifying {
    float: left;
    width: 80px;
    height: calc(100% - 138px);
    position: absolute;
    left: 432px;
    top: 50px;
    overflow: hidden;
    border-top: 1px solid #000;
    .body {
      width: 100%;
      height: calc(100% - 20px);
      overflow-y: scroll;
    }
    .mnf_btn {
      width: 100%;
      height: 150px;
      /*margin-top: 5px;*/
      /*border-bottom: 1px solid #333;*/
    }
    button {
      width: 55px;
      height: 20px;
      border-radius: 3px;
      background: #333;
      border: 1px solid #444;
      font-size: 12px;
    }
  }
  .calendar_box_save {
    // width: calc(100% - 520px);
    width: 400px;
    position: absolute;
    right: 0px;
    // left: 520px;
    left: 600px;
    top: 100px;
    z-index: 3000;
    // left: 340px;
    height: 177px;
    background: #444;
    padding: 51px 0 0 17px;
    text-align: left;
  }
  .tableSaveFooter {
    position: absolute;
    right: 0px;
    bottom: 0px;
    /* top: 100px; */
    left: 518px;
    background: #444;
    z-index: 2000;
  }
  .calendar_box {
    width: calc(100% - 518px);
    position: absolute;
    right: 0px;
    left: 515px;
    height: 850px;
    background: #444;
    .tableSaveFooter {
      position: absolute;
      right: 0px;
      bottom: 0;
      left: 600px;
    }
    .count_down {
      width: 280px;
      height: 36px;
      line-height: 36px;
      color: rgb(255, 192, 0);
      visibility: hidden;
      border: 1px solid #ccc;
      margin-top: 5px;
      padding: 0 10px;
      border-radius: 5px;
      span {
        width: 25%;
      }
    }
    .count_down.visib {
      visibility: visible;
    }
    /deep/ .fc-more-popover {
      max-height: 200px;
      overflow: scroll;
    }
    // cal_date_opt
    /deep/ .date_option .el-input__inner {
      border: none;
      background-color: transparent;
      color: transparent;
    }
    /deep/ .fc-unthemed {
      th,
      td,
      thead,
      tbody,
      .fc-divider,
      .fc-row,
      .fc-content,
      .fc-popover,
      .fc-list-view,
      .fc-list-heading td {
        border-color: #333;
      }
    }
    /deep/ .fc-toolbar.fc-header-toolbar {
      padding-right: 80px;
      margin-bottom: 0;
      height: 50px;
    }
    /deep/ .fc-unthemed .fc-head-container.fc-widget-header {
      border-top-color: #000;
    }
    /deep/ .fc-right .fc-button-group {
      width: 230px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      overflow: hidden;
      background-color: #666;
      text-align: center;
      cursor: pointer;
      margin-top: 10px;
      button {
        float: left;
        width: 33.3%;
        height: 100%;
        border-right: 1px solid #999;
        background: #666;
        color: #fff;
        border: none;
        text-shadow: none;
      }
      /deep/ .fc-state-active {
        background: #999;
        border-top: none;
      }
    }
    /deep/ .fc-toolbar.fc-header-toolbar {
      padding-right: 80px;
      .fc-center {
        position: relative;
        width: 250px;
        > div {
          width: 100%;
          h2 {
            text-align: center;
          }
          button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background-color: #444;
            background-image: none;
            box-shadow: none;
            text-shadow: none;
            border: none;
            .fc-icon {
              font-size: 17px;
              color: #fff;
              font-weight: normal;
            }
          }
          .fc-prev-button {
            left: 0;
          }
          .fc-next-button {
            right: 0;
          }
        }
      }
    }
    /deep/ .fc-event,
    .fc-event-dot {
      background-color: rgb(15, 190, 113);
      border: none;
    }
    /deep/ .fc-time-grid-event.fc-short .fc-time span {
      display: inline;
    }
    /deep/ .fc-time-grid-event.fc-short .fc-time::before,
    /deep/ .fc-time-grid-event.fc-short .fc-time::after {
      content: '';
    }
  }
  /deep/ .create_booking {
    position: absolute;
    width: 4rem;
    height: 3rem;
    // background-color: rgba(201, 201, 201, 1);
    // background-color: #dcdcdc;
    background-color: #252525;

    border-radius: 4px;
    z-index: 2038;
    padding: 0.16rem;
    padding-right: 0.2rem;
    color: #999;
    font-size: 0.16rem;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
    .create_title {
      margin-bottom: 15px;
      .separator {
        padding: 0 10px;
      }
      li.active {
        // color: #000;
        color: #33ab4f;
      }
      .event_color {
        width: 20px;
        height: 20px;
        // background: rgb(15, 190, 113);
        margin-right: 10px;
        border: none;
      }
      .event_title {
        text-align: left;
        font-size: 16px;
        // color: #000;
        width: 80%;
      }
    }
    .event_content_detail {
      font-size: 12px;
      // color: #000;
      .detail_item {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        padding: 0 10px;
        margin-bottom: 0;
        span:first-child {
          color: #666;
        }
        span:nth-child(2) {
          width: 78%;
          text-align: right;
        }
        .SCTESelet {
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            text-align: left;
            font-size: 12px;
            color: #666666;
            margin-right: 20px;
          }
          .el-input__inner {
            border: none;
            color: #999;
            font-size: 12px;
            width: 165px;
            text-align: right;
          }
        }
      }
      margin-bottom: 10px;
    }
    .c_itemdetail {
      //   margin-bottom: 10px;
      background-color: #444;
      color: #999;
      display: flex;
      padding: 10px 0 0 0;
      font-size: 12px;
      //  justify-content: space-around;
      .c_itemdetail_item {
        width: 27%;
      }
      .c_itemdetail_items {
        width: 30%;
        float: left;
        margin-left: 20%;
      }
    }
    .c_itemdetails {
      font-size: 12px;
      margin-bottom: 10px;
      background-color: #444;
      color: #999;
      .c_itemdetail_item {
        width: 16%;
      }
    }
    .c_item {
      height: 30px;
      margin-bottom: 10px;
      input {
        width: 310px;
        height: 30px;
        // background-color: rgba(228, 228, 228, 1);
        background-color: #444;
        // color: #000;
        color: #999;
        // border: 1px solid rgba(153,153,153,1);
        border: none;
        border-radius: 4px;
        text-indent: 10px;
        font-size: 12px;
        box-sizing: border-box;
      }
      .time_opt {
        width: 170px;
        height: 30px;
        // line-height: 30px;
        line-height: 26px;
        color: #000;

        background: rgba(228, 228, 228, 1);
        // border: 1px solid rgba(153, 153, 153, 1);
        border: none;
        border-radius: 4px;
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
        input.el-input__inner {
          width: 100%;
          background: #444;
          padding: 0;
          border: none;
          // line-height: 26px;
        }
        .el-input__prefix,
        .el-input__suffix-inner {
          display: none;
        }
      }
    }
    .RecordSelete {
      height: 20px;
    }
    .SCTESelet {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #444;
      height: 30px;
      border-radius: 4px;
      padding-left: 12px;
      margin-bottom: 10px;
      p {
        text-align: left;
        font-size: 12px;
        color: #666666;
        margin-right: 20px;
      }
      .el-input__inner {
        border: none;
        color: #999;
        font-size: 12px;
        width: 170px;
        text-align: right;
      }
    }
    .des.c_item {
      height: 60px;
      margin-bottom: 0px;
      textarea {
        resize: none;
      }
    }
    .note {
      .color_box {
        height: 100%;
        padding-right: 22px;
      }
      .color_opt {
        width: 255px;
        height: 40px;
        // background: #fff;
        background: #333;
        color: #999;
        border-radius: 4px;
        position: absolute;
        right: -11px;
        top: 31px;
        padding: 10px 0;
        padding-left: 6px;
        font-size: 12px;
        line-height: 20px;
        z-index: 10000;
        li {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .color_opt.triangle:before {
        left: 196px;
      }
      .color {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        margin-top: 4px;
        box-sizing: content-box;
      }
      .el-icon-caret-bottom {
        font-size: 20px;
        position: absolute;
        top: 16%;
        right: 0px;
        transform: translateY(-50%);
        transform: rotate(0deg);
        transition: 0.3s;
      }
      .el-icon-caret-bottom.top {
        transform: rotate(-180deg);
      }
      .to {
        // color: #000;
        color: #999;
        margin-left: 7px;
        line-height: 30px;
        font-size: 12px;
      }
      .reporter,
      textarea {
        width: 367px;
        // border: 1px solid rgba(153, 153, 153, 1);
        border: none;
      }
      textarea {
        // background: rgba(228, 228, 228, 1);
        background: #444;
        border-radius: 4px;
        height: 60px;
        // color: #000;
        color: #999;

        font-size: 12px;
        line-height: 15.6px;
        padding: 2px 2px 2px 10px;
        box-sizing: border-box;
      }
    }
    .create_footer {
      margin-top: 15px;
      button {
        width: 86px;
        height: 30px;
        background: #999;
        color: #fff;
        border: none;
        border-radius: 4px;
        font-size: 12px;
      }
      .save,
      .edit {
        background-color: #0c6;
        margin-left: 10px;
      }
      .delete {
        width: 72px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid rgba(153, 153, 153, 1);
        background: transparent;
        // color: #333;
      }
      .copy {
        margin-left: 100px;
        color: #39aa50;
        border: 1px solid #39aa50;
        background: transparent;
      }
      .end_live {
        background: #f00;
        color: #fff;
      }
    }
    .device {
      color: rgb(102, 102, 102);
      margin: 0 9px;
      .d_item {
        width: 100%;
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        font-size: 12px;
        padding: 0 20px 0 10px;
        .val {
          color: #999;
          width: 56%;
          text-align: right;
        }
        .ipt {
          float: right;
          height: 25px;
          width: 135px;
          margin-top: 3px;
          margin-right: -20px;
          border: none;
          padding-left: 10px;
          padding-right: 20px;
          box-sizing: border-box;
          color: #999;
          background-color: transparent;
          text-align: right;
        }
        .scte_ipt {
          color: #000;
        }
        .delay.active,
        .bitrate.active {
          text-align: left;
          background-color: #fff;
          color: #333;
        }
        .triangle:before {
          top: 60%;
          left: 95%;
          transform: translateY(-50%);
          border-color: transparent;
          border-top-color: #999;
          border-width: 6px;
          transition: 0.3s;
        }
        .triangle.up:before {
          top: 23%;
          transform: rotate(-180deg);
        }
        .createbox_r_list {
          position: absolute;
          right: 0;
          top: 32px;
          background: #ababab;
          width: 2.2rem;
          height: 170px;
          text-align: left;
          color: #333;
          li {
            padding-left: 10px;
            height: 32px;
            line-height: 32px;
            box-sizing: border-box;
            font-size: 12px;
          }
          li:hover {
            background: rgba(0, 208, 105, 0.2);
          }
          .el-scrollbar__thumb {
            background: #fff;
          }
        }
      }
      .d_item.source {
        input {
          float: right;
          border: none;
          height: 25px;
          width: 100px;
          padding-left: 10px;
          padding-right: 25px;
          margin-right: -20px;
          margin-top: 3px;
          box-sizing: content-box;
          color: #000;
        }
      }
    }
  }
  /deep/ .create_booking.triangle:before {
    border-top-color: #dcdcdc;
    border-right-color: #dcdcdc;
    border-bottom-color: transparent;
    left: 0.6rem;
    top: -0.095rem;
    border-width: 12px;
    box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
    transform: rotate(-45deg);
  }
  /deep/ .create_booking.right.triangle:before {
    left: 3.15rem;
  }
  /deep/ .create_booking.bottom.triangle:before {
    top: 3.35rem;
    transform: rotate(135deg);
  }
  /deep/ .create_booking.bottom.device.triangle:before {
    top: 2.46rem;
  }
  /deep/ .el-checkbox .el-checkbox__inner {
    background: transparent;
  }
  /deep/ .el-checkbox .el-checkbox__inner::after {
    border-color: #33ab4f;
    left: 4px;
    top: 0;
  }
  /deep/ .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #fff;
    border-color: transparent;
  }
  /deep/ .el-checkbox__inner:hover {
    border-color: #fff;
  }
  /deep/ .el-checkbox__input.is_focus {
    border-color: #fff;
  }
  /deep/.el-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
    font-size: 12px;
  }
  /deep/ .el-checkbox .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }
  /deep/ .el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: transparent;
  }
  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
  /deep/ .el-checkbox {
    display: block;
    margin: 0;
    padding-left: 8px;
    height: 24px;
    line-height: 24px;
    margin-bottom: 6px;
  }
  /deep/ .el-checkbox:hover {
    background-color: rgba(57, 170, 80, 0.25);
  }
  /deep/ .item_content.pointer div {
    margin: 0 !important;
  }
}
/deep/ .cal_date_opt {
  margin-left: 20%;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  i {
    font-size: 18px;
  }
  .el-input__suffix,
  .el-input__prefix {
    display: none;
  }
  /deep/ .el-date-editor input {
    color: transparent;
  }
}
/deep/ .replace_title {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: #fff;
}
// /deep/ .el-input__inner {
//   background-color: transparent;
//   z-index: 1000;
//   position: relative;
//   // color: transparent;
//   cursor: pointer;
// }
/deep/ #calendar .fc-center {
  visibility: hidden;
  display: none;
}
/deep/ #calendar .fc-header-toolbar {
  margin-bottom: 0;
}
/deep/ .fc-time-grid-event.fc-helper {
  overflow: visible;
}
/deep/ .el-popper[x-placement^='top'] .popper__arrow:after {
  background: #fff;
}
/deep/ .calendar .calendar_box .fc-unthemed th {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  background: #555;
  // color: #fff;
  color: #ccc;
  font: 400 normal 14px/50px 'Microsoft yahei';
}
/deep/ .fc-axis.fc-widget-header,
/deep/ .fc-axis.fc-time.fc-widget-content {
  width: 39px !important;
  box-sizing: border-box;
}
/deep/ .fc-unthemed td.fc-today {
  background-color: #666;
}
/deep/.fc-time-grid .fc-slats td {
  height: 150px;
}
/deep/ .fc-axis.fc-time.fc-widget-content span {
  font-size: 12px;
}
/deep/ .antline {
  // position: relative;
  background-color: #3f5d46 !important;
  padding: 2px;
  background-image: -webkit-linear-gradient(
    -45deg,
    rgba(16, 180, 103, 1) 25%,
    rgba(16, 180, 103, 0) 25%,
    rgba(16, 180, 103, 0) 50%,
    rgba(16, 180, 103, 1) 50%,
    rgba(16, 180, 103, 1) 75%,
    rgba(16, 180, 103, 0) 75%,
    rgba(16, 180, 103, 0)
  );
  background-size: 10px 10px;
  animation: antline 0.8s linear infinite;
  box-sizing: content-box;
}
/deep/ .fc-title {
  color: #333;
}
/deep/ .antline::after {
  position: absolute;
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  display: block;
  content: '';
  background-color: #3f5d46;
}
@keyframes antline {
  0% {
    background-position: 0px 0px;
  }
  50% {
    background-position: 0px 5px;
  }
  100% {
    background-position: 0px 10px;
  }
}
@media (max-width: 1660px) {
  /deep/ .fc-widget-content a.fc-event .fc-content .fc-title {
    width: 80%;
  }
  .cal_date_opt {
    margin-left: 5%;
  }
}
@media (max-width: 1500px) {
  // .calendar_box .cal_date_opt {
  //     margin-left: 17%;
  // }
  .calendar_box {
    .count_down {
      position: absolute;
      left: -280px;
    }
  }
}
@media (max-width: 1320px) {
  .calendar .calendar_box {
    .count_down {
      width: 180px;
    }
  }
}
@media (max-width: 1200px) {
  .calendar {
    width: 1200px;
  }
  /deep/ .fc-widget-content a.fc-event .fc-content .fc-title {
    width: 70%;
  }
  .calendar_box .cal_date_opt {
    margin-left: -2%;
  }
}

/deep/ .fc-time-grid-event.fc-event .fc-content .fc-time,
/deep/ .fc-day-grid-event.fc-h-event.fc-event .fc-content .fc-time {
  display: none;
}
/deep/ .fc-time-grid-event.fc-event.fc-helper.antline .fc-content .fc-time {
  display: block;
}
/deep/ .fc-widget-content .fc-content-col .fc-content {
  font-family: 'element-icons' !important;
  width: 100%;
}
/deep/ .fc-widget-content .fc-event .fc-content .fc-title {
  width: 90%;
  overflow: hidden;
  // white-space: nowrap;
  text-overflow: ellipsis;
  float: left;
}
/deep/ .fc-widget-content .fc-event .fc-content .el-icon-document-copy {
  margin-right: 3px;
  margin-top: 3px;
  display: none;
  color: #333;
}
/deep/ .fc-widget-content .fc-event .fc-content:hover .el-icon-document-copy {
  display: block;
}
/deep/ a.fc-event.fc-draggable {
  min-height: 1px;
  .fc-title {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }
}
/deep/ .fc-popover .fc-header {
  color: #333;
}
/deep/.recordInput {
  .el-checkbox__inner {
    background: #ffffff !important;
  }
}
.calendar {
  .calendar_box {
    .calendarEventWrap {
      /deep/ ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      /deep/ ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background-color: rgb(233, 233, 233);
        opacity: 0.7;
      }
      /deep/ ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 5px;
        background: none;
      }
      /deep/.purpleEvent {
        overflow: visible;
      }
      /deep/.purpleEvent::after {
        content: '';
        border-width: 5px 10px;
        border-style: solid;
        border-color: transparent rgba(255, 255, 255) transparent transparent;
        position: absolute;
        top: -5px;
        right: -10px;
      }
      /deep/.purpleEvent::before {
        content: '';
        border-width: 5px 10px;
        border-style: solid;
        border-color: transparent transparent transparent rgba(255, 255, 255);
        position: absolute;
        bottom: -5px;
        right: -20px;
      }
      /deep/.fc-time-grid-event .fc-content {
        overflow: hidden;
        height: 100%;
        position: relative;
        z-index: 1001;
      }
      /deep/.fc-time-grid .fc-event-container {
        z-index: auto;
      }
      /deep/ .fc-event {
        overflow: visible;
        .eventActiveBox {
          position: absolute;
          top: -40px;
          left: 0px;
          height: 42px;
          width: 150%;
          z-index: 100000000000;
          .eventMessageBox {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.5);
            border-radius: 3px;
            padding: 0px 10px;
            .eventMessageTitle {
              width: 70%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin: 0;
              color: #252525;
            }
            .iconfontWrap {
              height: 30px;
              display: flex;
              align-items: center;
              padding-right: 3px;
              position: absolute;
              right: 0;
              top: 0;
              i {
                color: #333;
              }
            }
          }
          .el-icon-caret-bottom {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -6px;
            font-size: 30px;
          }
          .el-icon-caret-top {
            display: none;
          }
        }
        .eventActiveBoxRight {
          left: -50%;
          z-index: 100000000000;
        }
        .eventActiveBoxBottom {
          top: 100%;
          z-index: 100000000000;
          .eventMessageBox {
            transform: translateY(11px);
          }
          .el-icon-caret-bottom {
            display: none;
          }
          .el-icon-caret-top {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -9px;
            font-size: 30px;
            display: inline;
          }
        }
      }
      /deep/.fc-day-grid .fc-row {
        overflow: visible;
      }
      /deep/ .ScteListWrap {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1000;
        .ScteWrap {
          width: 100%;
          background-color: #333;
          color: #fff;
          text-align: center;
          font-size: 12px;
          position: absolute;
          p {
            width: 100%;
            height: 100%;
            overflow: hidden;
          }
          span {
            position: absolute;
            right: 10px;
            top: 0;
            i {
              color: #fff;
            }
          }
        }
        .ScteWrap::after {
          content: '';
          border-width: 5px 10px;
          border-style: solid;
          border-color: transparent rgba(255, 255, 255) transparent transparent;
          position: absolute;
          top: -5px;
          right: -10px;
        }
        .ScteWrap::before {
          content: '';
          border-width: 5px 10px;
          border-style: solid;
          border-color: transparent transparent transparent rgba(255, 255, 255);
          position: absolute;
          bottom: -5px;
          right: -20px;
        }
      }
    }
  }
  .magnifying .body::-webkit-scrollbar-thumb {
    display: none;
  }
}
</style>
